import type { TranslationKey } from "../index";

export const ru: Record<TranslationKey, string> = {
    // --- common — short words/phrases reused verbatim across unrelated components ------------------
    "common.brandHomeAriaLabel": "SoundCheckBox — главная",
    "common.close": "Закрыть",
    "catalogCard.open": "Карточка из каталога",
    "catalogCard.openAlternatives": "Карточки альтернатив",
    "catalogCard.alternatives": "Альтернативы",
    "catalogCard.type": "Тип",
    "catalogCard.category": "Раздел",
    "catalogCard.weight": "Вес",
    "catalogCard.power": "Мощность",
    "about.heading": "О сборке",
    "about.web": "Веб",
    "about.api": "API",
    "about.schema": "Контракт схемы",
    "about.unknown": "неизвестно",
    "about.unstamped": "сборка без штампа",
    "about.envProduction": "Продакшн",
    "about.envNotProduction": "{env} — не продакшн",
    "about.mismatch": "Веб и API собраны из разных коммитов. Деплой доехал наполовину: то, что вы видите, и то, что отвечает, — разный код.",
    "common.cancel": "Отмена",
    "common.delete": "Удалить",
    "ridersList.deletePublished.heading": "Этот райдер опубликован",
    "ridersList.deletePublished.body": "Удаление погасит и публичную ссылку. Все, у кого она есть — площадка, прокатчик, тот кто сканировал распечатанный QR, — больше не смогут её открыть, и вернуть её будет нельзя.",
    "ridersList.deletePublished.dontAskAgain": "Больше не спрашивать в эту сессию",
    "common.deletePermanentlyPrompt": "Удалить навсегда?",
    "common.yesDelete": "Да, удалить",
    "common.loading": "Загрузка…",
    "common.saving": "Сохранение…",
    "common.sending": "Отправка…",

    // --- side-nav (components/side-nav.ts) ----------------------------------------------------------
    "sideNav.home": "Главная",
    "sideNav.soundman": "Звукорежиссер",
    "sideNav.soundmanComingSoon": "Звукорежиссер — скоро",
    "sideNav.myRiders": "Мои райдеры",
    "sideNav.offers": "Предложения",
    "myEquipment.warehouse.heading": "Мой склад",
    "myEquipment.warehouse.search": "Поиск по моему складу",
    "myEquipment.warehouse.add": "Добавить на мой склад",
    "myEquipment.warehouse.formed": "Мой склад сформирован — в офферах сначала предлагать из него",
    "myEquipment.backToOffer": "← Назад к офферу",
    "myEquipment.fromOffer.line": "Из {offer} на райдер {rider} на ваш склад добавлено: {items}.",
    "myEquipment.fromOffer.grow": "Расширьте склад:",
    "myEquipment.fromOffer.pick": "Выбрать из нашего каталога",
    "myEquipment.fromOffer.import": "Загрузить свой список",
    "myEquipment.fromOffer.dismiss": "Скрыть",
    "myEquipment.weight.notSpecified": "не указано",
    "myEquipment.col.manufacturer": "Производитель",
    "myEquipment.sort.by": "Сортировка",
    "myEquipment.sort.category": "Категория",
    "myEquipment.more": "Ещё",
    "myEquipment.searchClose": "Закрыть поиск",
    "sideNav.inbox": "Входящие",
    "sideNav.inboxComingSoon": "Входящие — скоро",
    "sideNav.outbox": "Исходящие",
    "sideNav.outboxComingSoon": "Исходящие — скоро",
    "sideNav.eventManager": "Организатор",
    "sideNav.eventManagerComingSoon": "Организатор — скоро",
    "sideNav.warehouse": "Склад",
    "sideNav.warehouseComingSoon": "Склад — скоро",
    "sideNav.myProfile": "Мой профиль",
    "sideNav.admin": "Администрирование",
    "sideNav.designThemeLabel": "Тема оформления",
    "sideNav.languageLabel": "Язык",
    "sideNav.mainAriaLabel": "Главное меню",

    // --- app-header (components/app-header.ts) ------------------------------------------------------
    "appHeader.adminTitle": "Администратор",
    "appHeader.adminBadge": "админ",
    "appHeader.logoutTitle": "Выйти из системы",
    "appHeader.logoutLabel": "Выйти",

    // --- verify-email banner (components/verify-email-banner.ts) -------------------------------------
    "verifyBanner.message": "Ваш email ещё не подтверждён — сохранение, публикация и другие изменения недоступны, пока вы его не подтвердите.",
    "verifyBanner.profileLink": "Перейти в профиль",
    "verifyBanner.resend": "Отправить письмо с подтверждением повторно",
    "verifyBanner.resendSent": "Отправлено ✓",
    "verifyBanner.resendFailed": "Не удалось отправить письмо повторно — попробуйте ещё раз со страницы профиля.",
    "verifyBanner.dismissAriaLabel": "Скрыть",

    // --- write errors shown in place of a raw API error (api/http.ts#isEmailNotVerifiedError) --------
    "errors.emailNotVerified": "Подтвердите email, прежде чем вносить изменения — перейдите в профиль, чтобы отправить ссылку повторно.",

    // --- login (pages/login-page.ts) -----------------------------------------------------------------
    "login.hint": "Войдите или создайте аккаунт, чтобы создавать и сохранять технические райдеры.",
    "login.hintRegister": "Создайте аккаунт — нужны почта и пароль, а работа перейдёт с вами.",
    "login.emailLabel": "Email или логин",
    "login.passwordLabel": "Пароль",
    "login.submit": "Войти",
    "login.register": "Зарегистрироваться",
    "login.consentNotice": "Создавая аккаунт, вы соглашаетесь с {termsLink} и {privacyLink}.",
    "login.termsLink": "Правилами пользования",
    "login.privacyLink": "Политикой конфиденциальности",
    "legal.privacyTitle": "Политика конфиденциальности",
    "legal.termsTitle": "Правила пользования",
    "legal.unavailable": "Не удалось загрузить документ. Попробуйте позже.",
    "consent.title": "Ознакомьтесь с условиями",
    "consent.body": "Чтобы продолжить пользоваться SoundCheckBox, примите {termsLink} и {privacyLink}.",
    "consent.changeNote": "Мы можем обновлять эти документы. Если вы не согласны с изменением, вы можете прекратить пользоваться сервисом.",
    "consent.agree": "Принимаю",
    "consent.decline": "Выйти",
    "consent.saveFailed": "Не удалось сохранить согласие. Попробуйте ещё раз.",
    "editor.publishConfirm": "Райдер будет опубликован по публичной ссылке — открыть сможет любой, без аккаунта, и она останется доступной, пока вы не снимете публикацию. Всё, что в нём написано, включая имена, телефоны и адреса почты, тоже станет публичным. Опубликовать?",
    "editor.publishImpact.offer": "Этот райдер стоит в оффере, о котором ещё не договорились ({shows}). Новая версия изменит оффер — прокатчик будет отвечать на изменившиеся строки заново. Публикуем?",
    "editor.publishImpact.contract": "Этот райдер стоит под согласованным оффером ({shows}). Поменять его там нельзя без изменения контракта шоу: прокатчику придётся подтвердить разницу, а бригада увидит новую версию. Публикуем?",
    "editor.publishImpact.unnamedShow": "шоу без названия",
    "editor.unpublishConfirm": "Снятие публикации убивает ВСЕ публичные ссылки на этот райдер — и эту версию, и все предыдущие. Все, кому вы уже отправили ссылку, перестанут её открывать. Отменить это нельзя: повторная публикация создаёт НОВУЮ ссылку. Снять публикацию?",
    "editor.publishDirty.heading": "Опубликовать несохранённые изменения?",
    "editor.publishDirty.body": "Публикуется последняя сохранённая версия райдера, а последние изменения ещё не сохранены. Чтобы они попали в публикацию, сначала сохраните их.",
    "editor.publishDirty.saveAndPublish": "Сохранить и опубликовать",
    "login.minAge": "Для создания аккаунта вам должно быть не менее 16 лет.",
    "admin.title": "Панель администратора",
    "admin.notAvailable": "Страница доступна только администраторам.",
    "admin.users.title": "Пользователи",
    "admin.users.searchPlaceholder": "Поиск по email или логину",
    "admin.users.searchBtn": "Найти",
    "admin.users.showAdmins": "Показать администраторов",
    "admin.users.browseAll": "Показать всех",
    "admin.users.prevPage": "Назад",
    "admin.users.nextPage": "Вперёд",
    "admin.users.pageOf": "Страница {page} из {pages} — {total} аккаунтов",
    "admin.users.searchTooShort": "Введите минимум 2 символа.",
    "admin.users.noMatch": "Совпадений нет.",
    "admin.users.colEmail": "Email",
    "admin.users.colLogin": "Логин",
    "admin.users.colJoined": "Регистрация",
    "admin.users.colVerified": "Подтверждён",
    "admin.users.colAdmin": "Админ",
    "admin.users.colActions": "Действия",
    "admin.users.verify": "Подтвердить email",
    "admin.users.grantAdmin": "Сделать админом",
    "admin.users.revokeAdmin": "Снять админа",
    "admin.users.verified": "Email отмечен подтверждённым.",
    "admin.users.granted": "Права администратора выданы.",
    "admin.users.revoked": "Права администратора сняты.",
    "admin.users.confirmGrant": "Выдать права администратора: {user}?",
    "admin.users.confirmRevoke": "Снять права администратора: {user}?",
    "admin.users.deletionPending": "запрошено удаление",
    "admin.users.tempPassword": "Временный пароль",
    "admin.users.tempPasswordPending": "временный пароль",
    "admin.users.confirmTempPassword": "Выдать временный пароль пользователю {user}? Текущий пароль перестанет работать сразу.",
    "admin.users.tempPasswordIssued": "Временный пароль для {user}. Скопируйте сейчас — показать его снова нельзя:",
    "admin.users.tempPasswordDone": "Временный пароль выдан.",
    // --- users tab: sort, filters, summary (SCRUM-570) ---
    "admin.users.colLastLogin": "Последний вход",
    "admin.users.colRiders": "Райдеров",
    "admin.users.colLastRiderEdit": "Последняя правка райдера",
    "admin.users.sortBy": "Сортировать по столбцу «{column}»",
    "admin.users.noLoginRecorded": "Не записано. Входы учитываются только с октября 2026 года — раньше они не сохранялись, так что прочерк не значит, что аккаунтом не пользовались.",
    "admin.users.noRiderEdit": "У аккаунта нет райдеров, поэтому и правок нет.",
    "admin.users.filtersTitle": "Фильтры",
    "admin.users.filterAll": "Все",
    "admin.users.filterRole": "Роль",
    "admin.users.filterRoleUsers": "Пользователи",
    "admin.users.filterRoleAdmins": "Администраторы",
    "admin.users.filterVerified": "Email подтверждён",
    "admin.users.filterVerifiedYes": "Подтверждён",
    "admin.users.filterVerifiedNo": "Не подтверждён",
    "admin.users.filterRiders": "Райдеры",
    "admin.users.filterRidersWith": "Есть райдеры",
    "admin.users.filterRidersWithout": "Нет райдеров",
    "admin.users.filterActiveDays": "Правил райдер за последние … дней",
    "admin.users.filterJoinedDays": "Зарегистрировался за последние … дней",
    "admin.users.filterAnyDays": "любое",
    "admin.users.clearFilters": "Сбросить фильтры",
    "admin.stats.title": "Сводка",
    "admin.stats.filteredHint": "Цифры — по аккаунтам, подходящим под фильтры выше.",
    "admin.stats.unfilteredHint": "Цифры — по всем аккаунтам.",
    "admin.stats.total": "Аккаунтов",
    "admin.stats.admins": "Администраторов",
    "admin.stats.verified": "Подтверждённых",
    "admin.stats.withRiders": "С райдерами",
    "admin.stats.ridersTotal": "Райдеров всего",
    "admin.stats.windowHeader": "За последние…",
    "admin.stats.days7": "7 дней",
    "admin.stats.days30": "30 дней",
    "admin.stats.days90": "90 дней",
    "admin.stats.days365": "365 дней",
    "admin.stats.activeRiderAuthors": "Правили райдер",
    "admin.stats.newUsers": "Зарегистрировались",
    "admin.stats.loggedIn": "Заходили",
    "admin.stats.loginNote": "Входы записываются только с октября 2026 года. Строка «Заходили» считается с этого дня; более ранние сессии в ней не учтены.",
    "admin.erasure.title": "Аккаунты к удалению",
    "admin.erasure.hint": "Запросы на удаление, у которых истёк срок ожидания. Автоматически ничего не удаляется: удаление необратимо и стирает аккаунт вместе со всеми его райдерами.",
    "admin.erasure.none": "Ничего не ждёт удаления.",
    "admin.erasure.colRequested": "Запрошено",
    "admin.erasure.colDue": "Срок истёк",
    "admin.erasure.erase": "Удалить",
    "admin.erasure.confirmPrompt": "Введите {user}, чтобы стереть аккаунт и все его райдеры. Отменить это нельзя.",
    "admin.erasure.confirmMismatch": "Адрес не совпал — ничего не удалено.",
    "admin.erasure.erased": "{user} удалён.",
    "admin.content.legalTitle": "Юридические документы",
    "admin.content.legalHint": "Заменяет документ, который поставляется с сайтом. Пусто — используется файл из репозитория, ровно как раньше. Формат — markdown.",
    "admin.content.mailTitle": "Тексты писем",
    "admin.content.mailHint": "Заменяет отдельные строки в письмах, для каждого языка отдельно. В поле лежит текст, который действует сейчас — правьте прямо в нём. Сохранение без изменений оставляет версию из поставки, «Вернуть» отменяет вашу правку. Плейсхолдеры в фигурных скобках нужно сохранять как есть — они подставляются при отправке.",
    "admin.content.localeLabel": "Язык",
    "admin.content.usingFile": "версия из поставки",
    "admin.content.edited": "изменено здесь",
    "admin.content.legalPlaceholder": "Пусто — сайт показывает документ из репозитория.",
    "admin.content.colKey": "Ключ",
    "admin.content.colText": "Текст",
    "admin.content.save": "Сохранить",
    "admin.content.revert": "Вернуть",
    "admin.content.saved": "Сохранено.",
    "admin.content.reverted": "Возвращена версия из поставки.",
    "admin.content.confirmRevert": "Отбросить правку и вернуть документ из поставки?",
    "admin.content.uiTitle": "Тексты интерфейса",
    "admin.content.uiHint": "Заменяет отдельные строки интерфейса, для каждого языка отдельно, без пересборки. В поле лежит текст, который действует сейчас — правьте прямо в нём. Сохранение без изменений оставляет версию из поставки, «Вернуть» отменяет вашу правку. Изменения видны всем после перезагрузки страницы.",
    "admin.content.uiSearchPlaceholder": "Поиск по ключу или тексту",
    "admin.content.uiEditedOnly": "только изменённые",
    "admin.content.uiStart": "Введите что-нибудь для поиска или отметьте «только изменённые».",
    "admin.content.uiTooMany": "Найдено {count} — показаны первые 200. Уточните поиск.",
    "admin.content.badPlaceholders": "Неизвестные подстановки: {list}. Они напечатаются как есть.",
    "admin.content.savedReload": "Сохранено. Перезагрузите страницу, чтобы увидеть.",
    "admin.tabs.users": "Аккаунты",
    "admin.tabs.content": "Тексты",
    "admin.tabs.settings": "Настройки",
    "admin.content.history": "История",
    "admin.content.noHistory": "Прошлых версий пока нет.",
    "admin.content.restore": "Загрузить эту версию",
    "admin.content.restoredIntoEditor": "Загружено в редактор — проверьте и сохраните.",
    "admin.settings.title": "Настройки сайта",
    "admin.settings.hint": "Изменения применяются сразу. Если значение не переопределено, используется зашитое в коде.",
    "admin.settings.save": "Сохранить",
    "admin.settings.reset": "Вернуть по умолчанию",
    "admin.settings.saved": "Сохранено: {key}.",
    "admin.settings.wasReset": "{key} возвращено к значению по умолчанию.",
    "admin.settings.overridden": "изменено (по умолчанию: {default})",
    "admin.settings.isDefault": "по умолчанию",
  "admin.models.title": "Неиспользуемые 3D-модели",
  "admin.models.hint": "Загруженные .glb, на которые не ссылается ни один пресет и ни один сохранённый райдер. Удаление необратимо — истории загрузок, из которой можно восстановить, нет.",
  "admin.models.scan": "Проверить",
  "admin.models.scanning": "Проверяю…",
  "admin.models.none": "Чистить нечего — все загруженные модели используются.",
  "admin.models.summary": "Не используется: {count}, всего {size}. Ещё используется: {inUse}. Просмотрено пресетов: {presets}, райдеров: {riders}.",
  "admin.models.colFile": "Файл",
  "admin.models.colSize": "Размер",
  "admin.models.colModified": "Загружен",
  "admin.models.deleteSelected": "Удалить выбранные",
  "admin.models.deleteSelectedCount": "Удалить выбранные ({count})",
  "admin.models.confirmDelete": "Удалить безвозвратно файлов моделей: {count}? Отменить это нельзя.",
  "admin.models.deleted": "Удалено файлов: {count}, освобождено {size}.",
  "admin.models.skipped": "Пропущено: {count} — на них уже есть ссылки.",
    "login.forgotPassword": "Забыли пароль?",
    "login.sessionExpired": "Сессия истекла — пожалуйста, войдите снова.",
    "login.invalidCredentials": "Неверный email/логин или пароль.",

    // --- recovery (pages/recovery-pages.ts) -----------------------------------------------------------
    "recovery.forgotTitle": "Сброс пароля",
    "recovery.forcedTitle": "Задайте свой пароль",
    "recovery.forcedLead": "Вы вошли по паролю, который выдала поддержка. Чтобы продолжить, задайте собственный — до этого остальные разделы недоступны.",
    "recovery.forcedCurrentLabel": "Временный пароль",
    "recovery.forcedSubmit": "Сохранить пароль",
    "recovery.forgotLead": "Введите ваш email, и мы отправим ссылку для смены пароля.",
    "recovery.emailLabel": "Email",
    "recovery.forgotSubmit": "Отправить ссылку для сброса",
    "recovery.backToSignIn": "Назад к входу",
    "recovery.forgotSuccess": "Если аккаунт с таким адресом существует, мы отправили ссылку для сброса. Проверьте почту и папку «Спам».",
    "recovery.resetIncompleteTitle": "Неполная ссылка для сброса",
    "recovery.resetIncompleteLead": "В этой ссылке отсутствует токен. Запросите новую ссылку.",
    "recovery.resetAgainLink": "Запросить новую ссылку для сброса",
    "recovery.resetTitle": "Выберите новый пароль",
    "recovery.newPasswordLabel": "Новый пароль",
    "recovery.repeatPasswordLabel": "Повторите новый пароль",
    "recovery.resetSubmit": "Установить новый пароль",
    "recovery.passwordMismatch": "Пароли не совпадают.",
    "recovery.resetSuccess": "Пароль обновлен. Перенаправляем на страницу входа…",
    "recovery.verifyTitle": "Подтверждение email",
    "recovery.verifyChecking": "Проверка ссылки…",
    "recovery.continueToSignIn": "Перейти к входу",
    "recovery.verifyNoToken": "В этой ссылке отсутствует токен. Запросите новый из вашего профиля.",
    "recovery.verifySuccess": "Ваш email подтвержден. Теперь вы можете войти.",
    "recovery.verifyFailed": "Ссылка для подтверждения недействительна или истекла. Войдите и запросите новую из вашего профиля.",
    "recovery.verifyChangeTitle": "Подтверждение нового email",
    "recovery.verifyChangeNoToken": "В этой ссылке отсутствует токен. Запросите новый из вашего профиля.",
    "recovery.verifyChangeSuccess": "Ваш новый email подтверждён — теперь входите с его помощью.",
    "recovery.verifyChangeFailed": "Ссылка для подтверждения недействительна или истекла. Войдите и запросите смену email заново из профиля.",

    // --- landing (pages/landing-page.ts) --------------------------------------------------------------
    "landing.nav.try": "Попробовать",
    "landing.nav.eventManager": "Организаторам",
    "landing.nav.rentCompany": "Прокатчикам",
    "landing.nav.soundman": "Звукорежиссерам",
    "landing.nav.howItWorks": "Как это работает",
    "landing.nav.contacts": "Контакты",
    "landing.nav.myRiders": "Мои райдеры",
    "landing.nav.login": "Войти",
    "landing.nav.signup": "Регистрация",
    "landing.hero.title": "Подготовь свое шоу",
    "landing.hero.sub": "Онлайн-сервис для подбора любого оборудования для концерта. Создавайте технический райдер со всеми деталями и находите прокатчиков в один клик.",
    "landing.hero.cta": "Открыть редактор",
    "landing.hero.mediaAlt": "3D редактор райдеров SoundCheckBox",
    "landing.try.title": "Соберите райдер прямо сейчас",
    "landing.try.lead": "Аккаунт не нужен. Редактор открывается сразу, а работа хранится в этом браузере — аккаунт понадобится, только чтобы её сохранить, отправить или поделиться ссылкой.",
    "landing.try.cta": "Открыть редактор",
    "landing.eventManager.title": "Организаторам мероприятий",
    "landing.eventManager.body":
        "Организуете фестиваль, тур, корпоратив или частный концерт? SoundCheckBox — это помощник, который хранит договоренности с группами и прокатчиками в одном месте.",
    "landing.eventManager.feature1Title": "Подбор оборудования",
    "landing.eventManager.feature1Desc": "Каждый запрос из райдера сопоставляется с реальным наличием у поставщиков.",
    "landing.eventManager.feature2Title": "Варианты выбора",
    "landing.eventManager.feature2Desc": "Сравнивайте предложения рядом вместо долгих переписок по почте.",
    "landing.eventManager.feature3Title": "Контроль договоренностей",
    "landing.eventManager.feature3Desc": "Надежность компании и отзывы с прошлых мероприятий видны до заключения сделки.",
    "landing.eventManager.feature4Title": "Оплата услуг",
    "landing.eventManager.feature4Desc": "Оплачивайте бронирование прямо на платформе.",
    "landing.eventManager.mediaAlt": "Процесс работы организатора",
    "landing.rentCompany.title": "Прокатным компаниям",
    "landing.rentCompany.body":
        "Автоматический менеджер, который читает входящий райдер, сверяет его с вашим складом и рассчитывает стоимость услуги.",
    "landing.rentCompany.feature1Title": "Сверка со складом",
    "landing.rentCompany.feature1Desc": "Райдеры сравниваются с вашим реальным наличием, а не со списком пожеланий.",
    "landing.rentCompany.feature2Title": "Авторасчет стоимости",
    "landing.rentCompany.feature2Desc": "Смета формируется по вашим прайсам сразу после получения райдера.",
    "landing.rentCompany.feature3Title": "Масштабные операции",
    "landing.rentCompany.feature3Desc": "Рассчитано на большие объемы хранения, поддерживается интеграция с вашим ПО.",
    "landing.rentCompany.feature4Title": "Субаренда",
    "landing.rentCompany.feature4Desc": "Не хватает прибора? Сервис подскажет, у кого его перехватить в аренду.",
    "landing.rentCompany.mediaAlt": "Процесс работы прокатной компании",
    "landing.soundman.title": "Звукорежиссерам",
    "landing.soundman.body":
        "Меньше бумажной рутины — больше времени на музыку. Собирайте райдер из готовых рабочих пресетов и используйте их для всех своих артистов.",
    "landing.soundman.feature1Title": "Проверенные сетапы",
    "landing.soundman.feature1Desc": "Начинайте с готового сценического плана, а не с чистого листа.",
    "landing.soundman.feature2Title": "Собственные пресеты",
    "landing.soundman.feature2Desc": "Сохраните наборы оборудования один раз и используйте их всегда.",
    "landing.soundman.feature3Title": "Управление группами",
    "landing.soundman.feature3Desc": "Ведите все свои группы и артистов в одном аккаунте.",
    "landing.soundman.feature4Title": "Готовые комплекты",
    "landing.soundman.feature4Desc": "Прокатные компании сами предложат точные комплекты под ваш райдер.",
    "landing.soundman.mediaAlt": "Процесс работы звукорежиссера",
    "landing.howItWorks.videoTitle": "SoundCheckBox — как это работает",
    "landing.howItWorks.lead":
        "Расставьте оборудование на 3D сцене, и стейджбокс, патч-лист и список оборудования сформируются автоматически. Распечатайте или отправьте прокатчику.",
    "landing.howItWorks.feature1Title": "1. Соберите сцену",
    "landing.howItWorks.feature1Desc": "Перетаскивайте пресеты — барабаны, бэклайн, микрофоны, мониторы — на сцену в масштабе.",
    "landing.howItWorks.feature2Title": "2. Списки пишутся сами",
    "landing.howItWorks.feature2Desc": "Каналы, источники и оборудование подтягиваются из того, что стоит на сцене.",
    "landing.howItWorks.feature3Title": "3. Поделитесь результатом",
    "landing.howItWorks.feature3Desc": "Распечатайте аккуратный райдер А4 со схемами или отправьте ссылку подрядчику.",
    "landing.contact.title": "Связаться с нами",
    "landing.contact.emailLabel": "Email",
    "landing.contact.addressLabel": "Адрес",
    "landing.contact.followUs": "Мы в соцсетях",
    "landing.contact.nameFieldLabel": "Ваше имя",
    "landing.contact.emailFieldLabel": "Ваш email",
    "landing.contact.messageLabel": "Сообщение",
    "landing.contact.submit": "Отправить сообщение",
    "landing.contact.captchaNote": "Защищено Cloudflare Turnstile — применяются {privacyLink} и {termsLink} Cloudflare.",
    "landing.contact.privacyPolicyLinkText": "Политика конфиденциальности",
    "landing.contact.termsLinkText": "Условия использования",
    "landing.contact.validationError": "Пожалуйста, укажите ваше имя, email и текст сообщения.",
    "landing.contact.success": "Спасибо! Ваше сообщение отправлено. Мы ответим на указанный email.",
    "landing.footer.tagline": "SoundCheckBox — конструктор технических райдеров",

    // --- riders list (pages/riders-list-page.ts) ------------------------------------------------------
    "riders.pageTitle": "Мои райдеры",
    "riders.newRiderButton": "Новый райдер",
    "riders.filter.groupLabel": "Фильтр райдеров по статусу",
    "riders.filter.all": "Все",
    "riders.filter.empty": "Нет райдеров, подходящих под этот фильтр.",
    "riders.table.title": "Название",
    "riders.table.band": "Группа / Артист",
    "riders.table.created": "Создан",
    "riders.table.changed": "Изменен",
    "riders.table.status": "Статус",
    "riders.table.action": "Действие",
    "riders.table.empty": "Райдеров пока нет — нажмите «+ Новый райдер», чтобы создать первый.",
    "riders.status.published": "Опубликован",
    "riders.status.draft": "Черновик",
    "riders.status.publicLinkTitle": "Публичная ссылка: {url}",
    "riders.actions.edit": "Редактировать",
    "riders.actions.moreActionsAriaLabel": "Другие действия для {title}",
    "riders.actions.publish": "Опубликовать",
    "riders.actions.unpublish": "Снять с публикации",
    "riders.actions.print": "Печать",
    "riders.actions.copyPublicLink": "Скопировать ссылку",
    "riders.actions.rename": "Переименовать",
    "riders.actions.duplicate": "Продублировать",
    "riders.copySuffix": "(копия)",
    "riders.copySuffixN": "(копия {n})",
    "riders.rename.heading": "Переименовать райдер",
    "riders.rename.nameLabel": "Новое имя",
    "riders.rename.confirm": "Переименовать",
    "riders.status.renaming": 'Переименовываем «{title}»…',
    "riders.status.renamed": 'Теперь называется «{title}».',
    "riders.status.renameFailed": 'Не удалось переименовать «{title}»: {message}',
    "riders.status.duplicating": 'Дублируем «{title}»…',
    "riders.status.duplicated": 'Создан «{title}».',
    "riders.status.duplicateFailed": 'Не удалось продублировать «{title}»: {message}',
    "riders.status.deleting": 'Удаление "{title}"…',
    "riders.status.deleted": 'Удален "{title}".',
    "riders.status.deleteFailed": 'Не удалось удалить "{title}": {message}',
    "riders.status.linkCopied": "Публичная ссылка скопирована: {url}",
    "riders.status.unpublished": 'Снят с публикации "{title}".',
    "riders.status.publishSuccess": 'Опубликован "{title}" — ссылка: {url}',
    "riders.status.unpublishFailed": 'Ошибка снятия с публикации "{title}": {message}',
    "riders.status.publishFailed": 'Ошибка публикации "{title}": {message}',
    "riders.status.publishedNoPicture": "На публичной странице нет картинки плана сцены: из списка её нарисовать нельзя. Опубликуйте из редактора, чтобы она появилась.",
    "riders.status.loading": "Загрузка ваших райдеров…",
    "riders.status.loadFailed": "Не удалось загрузить райдеры: {message}",

    // --- profile (pages/profile-page.ts) ---------------------------------------------------------------
    "profile.pageTitle": "Мой профиль",
    "profile.personal.title": "Личные данные",
    "profile.personal.nameLabel": "Имя",
    "profile.personal.phoneLabel": "Телефон",
    "profile.personal.countryLabel": "Страна",
    "profile.personal.cityLabel": "Город",
    "profile.personal.languageLabel": "Язык интерфейса",
    "profile.personal.save": "Сохранить личные данные",
    "profile.work.title": "Рабочая информация",
    "profile.work.companyLabel": "Компания / Команда",
    "profile.work.roleLabel": "Моя роль",
    "roleChoice.hint": "Определяет, какая страница откроется после входа.",
    "roleChoice.hintOptional": "Необязательно. Определяет, какая страница откроется после входа.",
    "profile.work.role.soundman": "Звукорежиссер",
    "profile.work.role.manager": "Организатор мероприятий",
    "profile.work.role.rental": "Прокатная компания",
    "profile.work.role.other": "Другое",
    "profile.work.save": "Сохранить рабочие данные",
    "profile.defaults.title": "Значения райдера по умолчанию",
    "profile.defaults.hint": "Эти данные подставляются в блок контактов каждого НОВОГО райдера. Каждый райдер сохраняет свои итоговые значения.",
    "profile.defaults.bandNameLabel": "Название группы",
    "profile.defaults.contactNameLabel": "Контактное лицо",
    "profile.defaults.contactPhoneLabel": "Контактный телефон",
    "profile.defaults.contactEmailLabel": "Контактный email",
    "profile.defaults.save": "Сохранить значения по умолчанию",
    "profile.security.title": "Безопасность",
    "profile.security.emailLabel": "Email",
    "profile.security.emailConfirmedLabel": "Email подтвержден",
    "profile.security.passwordChangedLabel": "Пароль изменен",
    "profile.security.memberSinceLabel": "Дата регистрации",
    "profile.security.emailVerifiedYes": "Да",
    "profile.security.emailVerifiedNot": "Еще нет",
    "profile.security.resendVerification": "Повторить письмо подтверждения",
    "profile.security.changePasswordTitle": "Сменить пароль",
    "profile.security.changePasswordSubmit": "Сменить пароль",
    "profile.security.currentPasswordLabel": "Текущий пароль",
    "profile.security.newPasswordLabel": "Новый пароль",
    "profile.security.repeatPasswordLabel": "Повторите новый пароль",
    "profile.security.resendSent": "Отправлено ✓",
    "profile.security.resendSuccess": "Письмо с подтверждением отправлено. Проверьте почту и папку «Спам».",
    "profile.security.passwordMismatch": "Новые пароли не совпадают.",
    "profile.security.passwordChanged": "Пароль изменен. Мы отправили подтверждение на вашу почту.",
    "profile.security.changeEmailTitle": "Смена email",
    "profile.security.changeEmailHint": "Мы отправим ссылку для подтверждения на новый адрес — ничего не изменится, пока вы не перейдёте по ней.",
    "profile.security.newEmailLabel": "Новый email",
    "profile.security.currentPasswordForEmailLabel": "Текущий пароль",
    "profile.security.changeEmailSubmit": "Отправить ссылку для подтверждения",
    "profile.security.changeEmailMissingFields": "Введите новый email и текущий пароль.",
    "profile.security.changePasswordMissingFields": "Введите текущий пароль и новый пароль не короче 8 символов.",
    "profile.security.changeEmailSuccess": "Если адрес {newEmail} свободен, ссылка для подтверждения уже отправлена туда. Проверьте почту и папку «Спам».",
    "profile.security.changeEmailPending": "Мы отправили ссылку для подтверждения на {newEmail}. Вы всё ещё входите как {currentEmail}, пока она не подтверждена.",
    "profile.ai.title": "ИИ-ассистент",
    "profile.ai.hint": "У ассистента есть небольшой бесплатный лимит. После него добавьте свой ключ Google Gemini, чтобы продолжить — вы платите Google напрямую, без лимита здесь.",
    "profile.ai.usageFree": "Использовано из бесплатного лимита: {used} из {cap}.",
    "profile.ai.usageByok": "Используется ваш ключ ({hint}) — без лимита.",
    "profile.ai.byokHint": "Вставьте свой ключ Gemini API, чтобы пользоваться ассистентом после бесплатного лимита.",
    "profile.ai.getKeyLink": "Получить бесплатный ключ",
    "profile.ai.keyLabel": "Ваш ключ Gemini API",
    "profile.ai.keyReplace": "введите новый ключ, чтобы заменить",
    "profile.ai.saveKey": "Сохранить ключ",
    "profile.ai.clearKey": "Удалить ключ",
    "profile.ai.byokUnavailable": "Свой ключ на этом сервере пока недоступен.",
    "profile.ai.keyRequired": "Сначала введите ключ API.",
    "profile.ai.keyValidating": "Проверяю ключ…",
    "profile.ai.keySaved": "Ключ сохранён — ассистент теперь использует его.",
    "profile.ai.keyCleared": "Ключ удалён.",
    "profile.ai.keySaveFailed": "Не удалось сохранить ключ: {message}",
    "profile.ai.loadFailed": "Не удалось загрузить данные об использовании ИИ.",
    "profile.privacy.title": "Данные и конфиденциальность",
    "profile.privacy.hint": "Ваши права в соответствии с GDPR и действующим законодательством.",
    "profile.privacy.downloadTitle": "Скачать мои данные",
    "profile.privacy.downloadHint": "Все ваши данные, включая созданные райдеры, в одном JSON-файле.",
    "profile.privacy.downloadButton": "Скачать",
    "profile.privacy.marketingTitle": "Продуктовая рассылка",
    "profile.privacy.marketingHint":
        "Новости о сервисе SoundCheckBox. Служебные письма (сброс пароля, подтверждения) отправляются всегда.",
    "profile.privacy.marketingCheckbox": "Получать продуктовые новости",
    "profile.privacy.deleteTitle": "Удалить аккаунт",
    "profile.privacy.deleteHint": "Навсегда удаляет ваш аккаунт и все принадлежащие вам райдеры.",
    "profile.privacy.deleteButton": "Удалить аккаунт",
    "profile.privacy.cancelDeleteButton": "Отменить удаление",
    "profile.status.loadFailed": "Не удалось загрузить профиль: {message}",
    "profile.status.personalSaved": "Личные данные сохранены.",
    "profile.status.workSaved": "Рабочая информация сохранена.",
    "profile.status.defaultsSaved": "Значения по умолчанию сохранены.",
    "profile.privacy.preparingExport": "Подготовка ваших данных…",
    "profile.privacy.exportDownloaded": "Файл с вашими данными скачан.",
    "profile.privacy.marketingOn": "Вы подписались на новости проекта.",
    "profile.privacy.marketingOff": "Вы отписались от рассылки новостей.",
    "profile.privacy.deleteConfirm":
        "Удалить аккаунт SoundCheckBox?\n\nВаш аккаунт и все райдеры будут окончательно удалены после льготного периода. Вы можете отменить удаление на этой странице до наступления этой даты.",
    "profile.privacy.deletionScheduled": "Удаление запланировано. Мы отправили подробности на ваш email — вы еще можете его отменить.",
    "profile.privacy.deletionCancelled": "Удаление отменено. Ваш аккаунт остается активным.",
    "profile.privacy.deletionPendingHint":
        "Удаление запланировано на {date}. Вы можете отменить его в любой момент до этой даты.",

    // --- public rider viewer (pages/public-viewer-page.ts) ---------------------------------------------
    "publicViewer.headerSub": "публичный райдер",
    "publicViewer.riderListsAriaLabel": "Списки райдера",
    "publicViewer.controls.grid": "Сетка",
    "publicViewer.controls.titles": "Подписи",
    "publicViewer.controls.inputCh": "Вход (CH)",
    "publicViewer.controls.outputMix": "Выход (MIX)",
    "publicViewer.controls.source": "Источник",
    "publicViewer.controls.comments": "Заметки",
    "publicViewer.window.close": "Закрыть окно",
    "publicViewer.window.zoomIn": "Увеличить масштаб списка",
    "publicViewer.window.zoomOut": "Уменьшить масштаб списка",
    "publicViewer.controls.scene": "3D-сцена",
    "publicViewer.controls.sceneLoading": "3D (загрузка...)",
    "publicViewer.controls.sceneHint": "Смотреть сцену в объёме — перетаскиванием её можно облететь.",
    "publicViewer.controls.plan": "Вид сверху",
    "publicViewer.controls.planHint": "Взгляд на сцену строго сверху, со стороны зала.",
    "publicViewer.controls.schematic": "Схема Ч/Б",
    "publicViewer.schematicLoading": "Собираю лист…",
    "publicViewer.schematicFailed": "Не удалось загрузить библиотеку условных знаков.",
    "publicViewer.controls.schematicHint": "Контрастная чёрно-белая схема сцены для печати и быстрого чтения.",
    "publicViewer.controls.schematicDisabledHint": "Пока не готов — чёрно-белый план ещё в работе.",
    "publicViewer.loaderAlt": "Загрузка данных и 3D-моделей...",
    "publicViewer.controls.hideStage": "Скрыть сцену",
    "publicViewer.controls.showStage": "Показать сцену",
    "publicViewer.controls.hideStageHint": "Скрыть сцену, чтобы листы и текст райдера заняли весь экран.",
    "publicViewer.controls.viewSwitchAriaLabel": "Вид сцены",
    "publicViewer.controls.follow": "Наводиться на выбранное",
    "publicViewer.controls.followHint": "При выборе канала камера подлетает к объекту-источнику.",
    "publicViewer.controls.labels": "Подписи",
    "publicViewer.controls.fit": "Вся сцена",
    "publicViewer.controls.fitHint": "Снова показать сцену целиком.",
    "publicViewer.controls.print": "Печать",
    "publicViewer.stageHint": "Зажмите для вращения, сжимайте/скролльте для зума, нажмите на объект для выбора.",
    "publicViewer.stageHintPlan": "Зажмите для перемещения плана, сжимайте/скролльте для зума, нажмите на объект для выбора.",
    "publicViewer.planPosterAlt": "План сцены, отрисованный при публикации этого райдера",
    "publicViewer.deselectAriaLabel": "Снять выделение",
    "publicViewer.tabs.rider": "Райдер",
    "publicViewer.tabs.input": "Входы",
    "publicViewer.tabs.output": "Выходы",
    "publicViewer.tabs.gear": "Оборудование",
    "publicViewer.bandLogoAlt": "Логотип группы",
    "publicViewer.table.ch": "Канал",
    "publicViewer.table.source": "Источник",
    "publicViewer.table.type": "Тип",
    "publicViewer.table.name": "Название",
    "publicViewer.table.comment": "Заметка",
    "publicViewer.table.category": "Категория",
    "publicViewer.table.owner": "Владелец",
    "publicViewer.table.count": "Количество",
    "publicViewer.footer": "Сделано в",
    "publicViewer.meta.inputCh": "Входных каналов",
    "publicViewer.meta.outputMix": "Выходных линий",
    "publicViewer.meta.gear": "Оборудование",
    "publicViewer.meta.gearCount": "{n} шт.",
    "publicViewer.noRiderNotes": "Заметок к райдеру нет.",
    "publicViewer.untitledRiderHeading": "Райдер без названия",
    "publicViewer.untitledRiderDocTitle": "Райдер",
    "publicViewer.documentTitle": "{title} — SoundCheckBox",
    "publicViewer.contactLabel": "Контакт: {name}",
    "publicViewer.telLabel": "Тел: {phone}",
    "publicViewer.emailLabel": "Email: {email}",
    "publicViewer.status.noRiderId": "Не указан ID райдера — в ссылке отсутствует идентификатор.",
    "publicViewer.status.withdrawn": "Автор отозвал этот райдер, и ссылка больше не работает.",
    "common.deletePublishedPrompt": "Удалить навсегда? Публичная ссылка перестанет работать у всех, у кого она есть.",
    "common.yesDeleteAndUnpublish": "Да, удалить и погасить ссылку",
    "publicViewer.status.notPublished": "Этот райдер не опубликован (или не существует). Попросите владельца опубликовать его.",
    "publicViewer.powerUnavailable": "Расчет энергопотребления недоступен.",
    "publicViewer.controls.makeOffer": "Сделать предложение",
    "publicViewer.controls.makeOfferHint": "Ответить на список каналов и оборудования этого райдера как поставщик.",
    "publicViewer.controls.compact": "Компактный вид",
    "publicViewer.controls.compactHint": "Чёрно-белый план и под ним короткий список каналов.",
    "publicViewer.controls.io": "I/O",
    "publicViewer.controls.ioHint": "Показать номера каналов и миксов на плане.",
    "publicViewer.controls.more": "Ещё",
    "publicViewer.controls.loadingWord": "(загрузка...)",
    "publicViewer.phantomTitle": "Фантомное питание (+48V)",
    "publicViewer.planFull.ariaLabel": "Открыть план на весь экран",
    "publicViewer.status.offerOwnRider": "Нельзя сделать предложение на собственный райдер.",
    "publicViewer.status.offerStartFailed": "Не удалось начать предложение: {error}",

    // --- offer mode (pages/offer-overlay.ts, PR2 — docs/V2_OFFER_TECH_APPROVAL.md) -----------------------
    "offer.loading": "Загрузка предложения…",
    "offer.loadFailed": "Не удалось загрузить это предложение: {error}",
    "offer.backToRider": "Назад к райдеру",
    "offer.status.draft": "Черновик",
    "offer.status.submitted": "Отправлено",
    "offer.status.changesRequested": "Запрошены правки",
    "offer.status.awaitingOrganiser": "Ожидает организатора",
    "offer.status.approved": "Утверждено",
    "offer.roundLabel": "Ответы v{n}",
    "offer.commentLabel": "Общий комментарий",
    "offer.commentPlaceholder": "Что автору райдера стоит знать об этом предложении в целом…",
    "offer.authorCommentHeading": "Автор райдера запросил правки",
    "offer.declinedReasonHeading": "Причина отказа от автора райдера",
    "offer.markRemainingOk": "Отметить остальное как OK",
    "offer.saveDraft": "Сохранить черновик",
    "offer.submit": "Отправить предложение",
    "offer.saving": "Сохранение…",
    "offer.savedStatus": "Черновик сохранён.",
    "offer.submitting": "Отправка…",
    "offer.submitFailed": "Не удалось отправить: {error}",
    "offer.saveFailed": "Не удалось сохранить: {error}",
    "offer.printFailed": "Не удалось напечатать: {error}",
    "offer.guest.notice": "Вы не вошли в аккаунт. Ответы хранятся в этом браузере, пока вы не отправите оффер.",
    "offer.myList.button": "Сверить с моим складом",
    "offer.myList.empty": "Ваш склад пуст — добавьте технику в разделе «Склад»",
    "offer.myList.link": "Склад",
    "offer.myList.summary": "{ok} позиций можно отметить OK по вашему списку, по {short} позициям у вас меньше, чем нужно, {missing} нет в вашем списке",
    "offer.myList.apply": "Применить",
    "offer.myList.cancel": "Отмена",
    "offer.myList.short": "у вас {have} из {need}",
    "offer.myList.marker": "из моего списка",
    "offer.myList.nothing": "Проверять нечего: на все позиции железа уже есть ответ.",
    "offer.guest.signInStep": "Чтобы отправить, войдите или создайте аккаунт — ваши ответы сохранятся.",
    "offer.guest.signInButton": "Войти или создать аккаунт",
    "offer.guest.keepEditing": "Продолжить редактирование",
    "offer.guest.emailLabel": "Ваша почта",
    "offer.guest.emailSend": "Отправить оффер",
    "offer.guest.emailHint": "Мы пришлём ссылку на почту. Откройте её — и оффер уйдёт, пароль не нужен.",
    "offer.guest.emailInvalid": "Введите правильный адрес почты.",
    "offer.guest.emailSent": "Мы отправили письмо на {email}. Откройте ссылку в нём — оффер уйдёт сам. Эту вкладку можно закрыть: ответы хранятся в этом браузере 48 часов.",
    "offer.guest.emailSendFailed": "Сейчас не получилось отправить письмо. Попробуйте ещё раз через минуту.",
    "offer.guest.emailAlreadySent": "Письмо для подтверждения уже отправлено на {email}. Откройте ссылку в нём — оффер уйдёт сам. Загляните в «Спам»: письмо от незнакомого отправителя часто попадает туда. Если его нет, попросите ещё раз через {minutes} мин.",
    "offer.guest.emailSentAgain": "Письмо для подтверждения уже отправлено на {email}, и мы отправили его ещё раз. Откройте ссылку в любом из писем — оффер уйдёт сам. Загляните в «Спам»: письмо от незнакомого отправителя часто попадает туда.",
    "offer.autoSending": "Отправляем оффер…",
    "offer.autoSent": "Оффер отправлен.",
    "offer.awaitingEmail": "Мы отправили письмо на {email}. Откройте ссылку в нём — оффер уйдёт сам.",
    "offer.where.title": "Когда и где — чтобы оффер попал в нужное шоу",
    "offer.where.dateLabel": "Дата",
    "offer.where.kind.range": "Период",
    "offer.where.kind.choice": "Несколько дат на выбор",
    "offer.where.kind.day": "Один день",
    "offer.where.pick.day": "Нажмите на день.",
    "offer.where.pick.range": "Нажмите первый день, затем последний.",
    "offer.where.pick.choice": "Нажмите каждую подходящую дату — не меньше двух.",
    "offer.where.clear": "Даты пока нет",
    "offer.where.prevMonth": "Предыдущий месяц",
    "offer.where.nextMonth": "Следующий месяц",
    "offer.where.chips": "Быстрый выбор",
    "offer.where.weekdays": "Подходящие дни",
    "offer.where.chip.thisWeek": "Эта неделя",
    "offer.where.chip.nextWeek": "Следующая неделя",
    "offer.where.chip.lastWeekOf": "Последняя неделя: {month}",
    "offer.where.chip.wholeMonth": "Весь месяц",
    "offer.where.possibleDays": "Возможных дней: {n}",
    "offer.where.removeDate": "Убрать дату",
    "offer.where.venue": "Площадка",
    "offer.where.city": "Город (необязательно)",
    "offer.where.hint": "Группа увидит ваш оффер внутри своего шоу на эту дату.",
    "offer.where.error.dayMissing": "Выберите дату.",
    "offer.where.error.rangeIncomplete": "Нажмите последний день периода.",
    "offer.where.error.rangeBackwards": "Диапазон заканчивается раньше, чем начинается.",
    "offer.where.error.rangeNoDays": "Все дни диапазона вычеркнуты — отметьте хотя бы один день недели.",
    "offer.where.error.choiceFew": "Выберите не меньше двух дат или перейдите на «Один день».",
    "offer.placed.whenVenue": "Ваш оффер для этого шоу ({when}, {venue}) отправлен, организаторы шоу рассматривают его, спасибо!",
    "offer.placed.when": "Ваш оффер для этого шоу ({when}) отправлен, организаторы шоу рассматривают его, спасибо!",
    "offer.placed.venue": "Ваш оффер для этого шоу ({venue}) отправлен, организаторы шоу рассматривают его, спасибо!",
    "offer.placed.none": "Ваш оффер для этого шоу отправлен, организаторы шоу рассматривают его, спасибо!",
    "offer.showLink.for": "Для: {parts}.",
    "offer.showLink.archived": "Это шоу уже согласовано — новые офферы не принимаются.",
    "offer.showLink.gone": "Ссылка на шоу не работает — её отозвали или её не удалось прочитать. Попросите группу прислать новую.",
    "offer.send.title": "Отправить оффер?",
    "offer.send.rider": "Райдер: {title}, v{version}",
    "offer.send.lines": "Строк: {total}",
    "offer.send.comment": "Ваш общий комментарий",
    "offer.send.ask": "Проверьте: укажите дату и площадку или скажите, что они ещё не определены.",
    "offer.send.notSet": "Дата и площадка ещё не определены",
    "offer.send.notSetOn": "Уйдёт с ответом: дата и площадка ещё не определены.",
    "offer.send.or": "или",
    "offer.send.send": "Отправить",
    "offer.send.back": "Вернуться к офферу",
    "offer.send.close": "Закрыть",
    "offer.send.need": "Укажите дату и площадку или нажмите «Дата и площадка ещё не определены».",
    "offer.send.viaLink": "Дата и площадка берутся из ссылки на шоу — заполнять нечего.",
    "offer.said.notSet": "Дата и площадка: ещё не определены (ответ поставщика)",
    "riders.actions.publishToShow": "Опубликовать в шоу",
    "publishShow.title": "Опубликовать в шоу",
    "publishShow.hint": "У шоу есть дата и площадка. Прокатчик, открывший ссылку, отвечает именно на это шоу.",
    "publishShow.whenWhere": "Когда и где",
    "publishShow.rider": "Райдер: {title}, v{version}",
    "publishShow.create": "Создать шоу и ссылку",
    "publishShow.creating": "Создаём шоу…",
    "publishShow.linkLabel": "Ссылка для прокатчиков",
    "publishShow.copy": "Копировать",
    "share.action": "Отправить",
    "share.hint": "Отправить райдер почтой, в WhatsApp, Telegram или любой мессенджер",
    "share.email": "Почта",
    "share.whatsapp": "WhatsApp",
    "share.telegram": "Telegram",
    "share.copyLink": "Скопировать ссылку",
    "share.copied": "Ссылка скопирована",
    "share.kind": "технический райдер",
    "publishShow.copied": "Скопировано",
    "publishShow.close": "Закрыть",
    "publishShow.notPublished": "Сначала опубликуйте райдер — шоу ссылается на опубликованную версию.",
    "publishShow.failed": "Не удалось создать шоу: {error}",
    "showPage.about": "Об этом шоу",
    "showPage.when": "Дата",
    "showPage.venue": "Площадка",
    "showPage.rider": "Райдер",
    "showPage.riderValue": "{title}, v{version}",
    "showPage.dateOpen": "Дата пока не согласована",
    "showPage.venueNone": "Площадка пока не выбрана",
    "showPage.makeOffer": "Сделать предложение",
    "showPage.archived.past": "Это шоу состоялось. Эта страница — его архив, новые предложения не принимаются.",
    "showPage.archived.agreed": "Это шоу согласовано. Эта страница — его архив, новые предложения не принимаются.",
    "showPage.repeat": "Повторить это шоу",
    "showPage.loadFailed": "Не удалось прочитать это шоу: {error}",
    "repeatShow.title": "Повторить это шоу",
    "repeatShow.hint": "Новое шоу с той же площадкой и теми же артистами. Прежнее остаётся как есть.",
    "repeatShow.whenWhere": "Новая дата",
    "repeatShow.rider.newer": "У райдера есть более новая версия (v{newest}; играли v{played})",
    "repeatShow.rider.quiet": "С шоу райдер не менялся (v{played}).",
    "repeatShow.rider.newest": "Взять новейшую",
    "repeatShow.rider.keep": "Оставить ту, что играли",
    "repeatShow.rider.ask": "Попросить у группы новый",
    "repeatShow.offers.title": "Предложения",
    "repeatShow.offers.count": "Согласованных предложений на этом шоу: {n}",
    "repeatShow.offers.invite": "Пригласить ту же компанию снова",
    "repeatShow.offers.none": "Начать без предложений",
    "repeatShow.create": "Создать новое шоу",
    "repeatShow.creating": "Создаём шоу…",
    "repeatShow.needAnswer": "Ответьте на вопросы выше, чтобы продолжить.",
    "repeatShow.done": "Новое шоу создано. Вот его ссылка для поставщиков:",
    "repeatShow.failed": "Не удалось повторить шоу: {error}",
    "emailLogin.title": "Вход",
    "emailLogin.checking": "Проверяем ссылку…",
    "emailLogin.failed": "Ссылка устарела или уже использована. Откройте райдер снова и нажмите «Отправить» — ответы хранятся в этом браузере 48 часов.",
    "emailLogin.noToken": "Ссылка неполная. Откройте её из письма ещё раз.",
    "emailLogin.success": "Вы вошли.",
    "emailLogin.offerFailed": "Оффер, отправленный с вашей почтой, не удалось доставить — возможно, райдер сняли с публикации. Откройте райдер и отправьте его ещё раз.",
    "emailLogin.usedTitle": "Эта ссылка уже использована",
    "emailLogin.usedBody": "Если вы отправляли по ней оффер — он ушёл и лежит в аккаунте {email}. Мы пришлём новую ссылку на тот же адрес: она откроет ваш аккаунт с оффером, и там можно задать пароль.",
    "emailLogin.usedBodyNoEmail": "Если вы отправляли по этой ссылке оффер — он ушёл. Введите почту, и мы пришлём новую ссылку в ваш аккаунт.",
    "emailLogin.emailLabel": "Ваша почта",
    "emailLogin.sendNew": "Прислать новую ссылку",
    "emailLogin.signIn": "У меня уже есть аккаунт — войти",
    "emailLogin.newSent": "Мы отправили новую ссылку на {email}. Откройте её — попадёте в свой аккаунт, к своему офферу.",
    "setPassword.title": "Задайте пароль, чтобы вернуться потом",
    "setPassword.hint": "Ваш аккаунт создан по ссылке из письма. С паролем вы сможете открыть его в любой момент и увидеть свой оффер и ответ автора.",
    "setPassword.label": "Новый пароль (не меньше 8 символов)",
    "setPassword.button": "Задать пароль",
    "setPassword.tooShort": "Пароль должен быть не короче 8 символов.",
    "setPassword.done": "Пароль задан. В следующий раз входите по почте и этому паролю.",
    "setPassword.failed": "Не получилось задать пароль. Попробуйте ещё раз.",
    "offer.validation.modelRequired": "Укажите модель для каждого ответа «Замена» перед сохранением.",
    "offer.validation.reasonRequired": "Укажите причину для каждого ответа «Недоступно» перед сохранением.",
    "offer.readOnlyNotice": "Это предложение в статусе «{status}» и больше не редактируется.",
    "offer.table.answer": "Ответ",
    "offer.bandBringsNote": "Это привозит коллектив",
    "offer.gear.consumables": "Расходники — из подтверждённых комплектов",
    "offer.gear.cablesElsewhere": "Кабели перечислены отдельным разделом ниже.",
    "offer.notConnectedNote": "Не подключено",
    "offer.answer.unanswered": "—",
    "offer.answer.ok": "OK",
    "offer.answer.markOk": "Подтвердить: OK",
    "offer.answer.substitute": "Замена",
    "offer.answer.bandCarried": "Привозит коллектив",
    "offer.answer.na": "Недоступно",
    "offer.answer.venueProvided": "Есть на площадке",
    "offer.answer.modelPlaceholder": "Модель",
    "offer.alt.warehouseEmpty": "В этой рубрике у вас ничего нет",
    "offer.alt.searchCatalogue": "Поискать в нашем каталоге",
    "offer.answer.reasonPlaceholder": "Причина",

    "offer.answer.commentPlaceholder": "Комментарий",
    "offer.answer.short.ok": "OK",
    "offer.answer.short.substitute": "Замена",
    "offer.answer.short.bandCarried": "Группа",
    "offer.answer.short.na": "Нет",
    "offer.answer.short.venueProvided": "Площадка",
    "offer.collapseAll": "Свернуть всё",
    "offer.expandAll": "Развернуть всё",
    "offer.patchShow": "Патч этого шоу →",
    "offer.confirmedOf": "Подтверждено {done} из {total}",
    "offer.summary.confirmed": "подтверждено",
    "offer.summary.alternatives": "с заменой",
    "offer.summary.unavailable": "нет",
    "offer.summary.open": "ещё не отвечено",
    "offer.summary.nothingYet": "Пока ничего не отвечено",
    "offer.allConfirmed": "Всё подтверждено",
    "offer.sectionToggle": "Свернуть или развернуть раздел",
    "offer.plan.title": "План сцены",
    "offer.plan.io": "I/O",
    "offer.plan.ioShow": "Показать подписи каналов и миксов",
    "offer.plan.ioHide": "Скрыть подписи каналов и миксов",
    "offer.plan.open": "Нажмите, чтобы открыть на весь экран",
    "offer.plan.close": "Закрыть",
    "offer.plan.zoomIn": "Приблизить",
    "offer.plan.zoomOut": "Отдалить",
    "offer.plan.loading": "Рисуем план сцены…",
    "offer.plan.failed": "План сцены не удалось нарисовать.",
    "offer.wire.checkPatch": "Проверить патч шоу и длины кабелей →",
    "offer.wire.hint": "Открывает редактор патча и солвер кабелей",
    "offer.wire.longMic": "Длинные микрофонные кабели",
    "offer.wire.shortPatch": "Короткие патч-кабели",
    "offer.detail.each": "Каждая из {n} — для чего",
    "offer.detail.kit": "комплект {name}",
    "offer.detail.kitHide": "комплект {name}",
    "offer.amp.summary": "{n} × LA4X amplified controller · {capacity} output channels · занято {used} · свободно {free}",
    "offer.amp.capacity": "drive capacity на один LA4X: 2 × 115XT HiQ или 4 × SB18 (L-Acoustics)",
    "offer.amp.channels": "{n} кан.",
    "offer.amp.twoWay": "2-way active (LF + HF)",
    "offer.amp.oneChannel": "1 output channel",
    "offer.amp.used": "{used}/{capacity} кан.",
    // --- offer review mode (pages/offer-review-overlay.ts, PR3 — docs/V2_OFFER_TECH_APPROVAL.md) -----
    "offer.review.supplierCommentLabel": "Комментарий поставщика",
    "offer.review.noComment": "Без комментария.",
    "offer.review.yourRequestHeading": "Запрошенные вами правки",
    "offer.review.approvedNotice": "Это предложение утверждено. Дальнейшие изменения невозможны.",
    "offer.review.approve": "Утвердить",
    "offer.review.requestChanges": "Запросить правки",
    "offer.review.requestChangesCommentLabel": "Что нужно поменять?",
    "offer.review.requestChangesCommentPlaceholder": "Опишите поставщику, что исправить перед повторной отправкой…",
    "offer.review.sendRequest": "Отправить",
    "offer.review.approving": "Утверждение…",
    "offer.review.approveFailed": "Не удалось утвердить: {error}",
    "offer.review.sending": "Отправка…",
    "offer.review.requestFailed": "Не удалось отправить: {error}",
    "offer.review.commentRequired": "Укажите, что нужно поменять, перед отправкой.",
    "offer.review.supplierNameUnknown": "Поставщик неизвестен",
    "offer.review.historyHeading": "История",
    "offer.review.history.submitted": "Отправлено",
    "offer.review.history.changesRequested": "Запрошены правки",
    "offer.review.history.approved": "Утверждено",
    "offer.status.declined": "Отклонено",
    "offer.review.decline": "Отклонить",
    "offer.review.declinedNotice": "Это предложение отклонено. Поставщик не может ни изменить его, ни отправить повторно.",
    "offer.review.declineConfirm": "Отклонить это предложение? Это окончательно: поставщик получит письмо и не сможет отправить его заново.",
    "offer.review.declineReasonLabel": "Причина (необязательно)",
    "offer.review.declineReasonPlaceholder": "Её увидит поставщик в письме…",
    "offer.review.declineConfirmButton": "Отклонить предложение",
    "offer.review.declining": "Отклоняем…",
    "offer.review.declineFailed": "Не удалось отклонить: {error}",
    "offer.review.history.declined": "Отклонено",

    // --- /offers — the two-sided offer inbox (pages/offers-page.ts, PR3) -----------------------------
    "offers.pageTitle": "Предложения",
    "offers.incomingHeading": "Предложения по моим райдерам",
    "offers.mineHeading": "Мои предложения",
    "offers.incomingEmpty": "Пока никто не ответил на ваш опубликованный райдер.",
    "offers.mineEmpty": "Вы ещё не сделали предложение по райдеру.",
    "offers.table.rider": "Райдер",
    "offers.table.supplier": "Поставщик",
    "offers.table.supplierUnknown": "Поставщик неизвестен",
    "offers.table.status": "Статус",
    "offers.table.round": "Раунд",
    "offers.table.updated": "Изменено",
    "offers.status.loading": "Загрузка…",
    "offers.status.loadFailed": "Не удалось загрузить предложения: {error}",

    // --- editor topbar (components/topbar.ts) -----------------------------------------------------------
    "topbar.loggedInAs": "вы вошли как {email}",
    "topbar.adminBadge": "админ",
    "topbar.adminBadgeTitle": "У вас есть права администратора (например, загрузка 3D объектов).",
    "topbar.unsavedRiderId": "(новый несохраненный райдер)",
    "topbar.save.title": "Сохранить райдер в базу данных ({mod}+S)",
    "topbar.save.copyTitle":
        "Сохранить как свою копию — этот райдер принадлежит другому пользователю. Сохранение создаст НОВЫЙ райдер в вашем аккаунте. ({mod}+S)",
    "topbar.save.copyLabel": "Сохранить как свою копию",
    "topbar.saveAs.title": "Сохранить как… — сохранить открытый райдер как НОВЫЙ под выбранным именем, не трогая исходный ({mod}+Shift+S)",
    "topbar.saveAs.label": "Сохранить как…",
    "topbar.attach.title": "Привязать объект к другому — активируйте, затем нажмите на родительский объект",
    "topbar.attach.label": "Привязать объект",
    "topbar.attach.armedTitle": "Режим привязки активен — кликните по объекту на 3D сцене, который станет родительским (Escape для отмены).",
    "topbar.attach.armedLabel": "Выберите цель…",
    "topbar.publish.label": "Опубликовать райдер",
    "topbar.publish.titleUnsaved": "Опубликовать райдер — сначала сохраните его",
    "topbar.publish.titleNotMine": "Опубликовать райдер — только владелец может опубликовать этот райдер",
    "topbar.publish.titlePublished": "Опубликован v{version} — ссылка: {url} (кликните, чтобы снять с публикации)",
    "topbar.publish.unpublishLabel": "Снять с публикации",
    "topbar.publish.titleDefault": "Опубликовать райдер — сделать доступным по публичной ссылке (для QR-кода на печатной версии)",

    // --- editor page chrome (pages/editor-page.ts, EDITOR_PAGE_HTML template) ----------------------------
    "editor.riderIdTitle": "ID сохраненного райдера (пусто = новый)",
    "editor.menuToggleTitle": "Свернуть/развернуть меню",
    "editor.menuToggleLabel": "Меню",
    "editor.overflowMenuTitle": "Ещё",
    "editor.rightPanelCollapseTitle": "Свернуть панель",
    "editor.rightPanelExpandTitle": "Развернуть панель",
    "editor.rightPanelResizerTitle": "Потяните, чтобы изменить ширину панели (двойной клик — сбросить до автоматической)",
    "editor.undoTitle": "Отменить ({mod}+Z)",
    "editor.undoLabel": "Отменить",
    "editor.redoTitle": "Повторить ({mod}+Shift+Z)",
    "editor.redoLabel": "Повторить",
    "editor.rotateTitle":
        "Поворот (R) — включите кольцо поворота и потяните его. По умолчанию поворачивает весь сет (объект с дочерними элементами); удерживайте Alt для поворота только объекта.",
    "editor.rotateLabel": "Повернуть",
    "editor.attachArmedHint": "Щёлкните предмет, к которому привязать «{title}», — подиум, стойку · Esc отменяет",
    "editor.modifierAltHint": "Alt — только этот объект",
    "editor.modifierAltStackHint": "Alt — вся стопка",
    "editor.modifierShiftHint": "Shift — щёлкайте по объектам, чтобы сгруппировать; отпустите, чтобы завершить (или отпустите над объектом при перетаскивании, чтобы приклеить)",
    "editor.uploadObjectTitleDisabled": "Загрузить 3D объект — только для админа",
    "editor.uploadObjectTitleAdmin": "Загрузить 3D объект — создать новый глобальный пресет из .glb",
    "editor.uploadObjectLabel": "Загрузить 3D объект",
    "editor.deleteObjectLabel": "Удалить выбранный объект",
    "editor.deleteObjectTitle": "Удалить выбранный объект (Alt+Delete)",
    "editor.savePresetLabel": "Сохранить пресет",
    "editor.deleteSubtreeLabel": "Удалить объект со всеми дочерними",
    "editor.deleteSubtreeTitle": "Удалить объект со всеми дочерними (Delete)",
    "editor.selectMode.groupLabel": "Вся стопка",
    "editor.selectMode.groupTitle": "Выделение: вся стопка — перетаскивание, поворот и удаление берут группу (Alt — один предмет)",
    "editor.selectMode.itemLabel": "Один предмет",
    "editor.selectMode.itemTitle": "Выделение: один предмет — перетаскивание, поворот и удаление берут тот, в который попал щелчок (Alt — вся стопка)",
    "editor.deleteInGroupLabel": "Удалить всю стопку",
    "editor.deleteInGroupTitle": "Удалить всю стопку (Delete) — Alt: только предмет под щелчком",
    "editor.deleteInItemLabel": "Удалить предмет",
    "editor.deleteInItemTitle": "Удалить предмет под щелчком (Delete) — Alt: всю стопку",
    "editor.deleteGroupConfirm.heading": "Удалить всю стопку?",
    "editor.deleteGroupConfirm.body": "«{title}» уедет со сцены вместе со всем, что на нём стоит. Предметов: {n}.",
    "editor.deleteGroupConfirm.confirmLabel": "Удалить стопку",
    "editor.showAnnotationsLabel": "Показать/скрыть аннотации",
    "editor.annotationOptionsTitle": "Параметры отображения аннотаций",
    "editor.annotationContentAriaLabel": "Содержимое аннотации",
    "editor.labelsPlaqueStrip": "LABELS",
    "editor.annotationCh": "CH",
    "editor.topViewTitle": "Вид сверху",
    "editor.topViewLabel": "Вид сверху",
    "editor.planViewTitle": "Чертёж плана",
    "editor.planViewLabel": "Чертёж",
    "editor.view3dLabel": "3D",
    "editor.view3dTitle": "Вид в 3D",
    "editor.topViewShort": "Top",
    "editor.planViewShort": "Plan",
    "editor.viewSwitcherAriaLabel": "Вид",
    "editor.viewSwitcherOptionsTitle": "Варианты вида",
    "editor.planViewLoading": "Собираю лист…",
    "editor.planViewFailed": "Не удалось загрузить библиотеку условных знаков.",
    "editor.status.planMoveRefused": "Этот предмет туда не переставить.",
    "presetMenu.editMode": "Изменить",
    "presetMenu.editModeDone": "Готово",
    "presetMenu.reorderFailed": "Не удалось сохранить порядок: {error}",
    "presetMenu.setDefaultOrder": "Сделать порядком по умолчанию",
    "presetMenu.defaultOrderSaved": "Теперь это порядок по умолчанию для всех, кто не расставил пресеты сам.",
    "editor.annotationSource": "Источник",
    "editor.annotationMix": "MIX",
    "editor.annotationTitle": "Название",
    "editor.annotationDesc": "Описание",
    "editor.showGridLabel": "Показать/скрыть координатную сетку",
    "editor.printLabel": "Печать райдера",
    "editor.printTitle": "Экспорт в PDF и печать",
    "editor.exitLabel": "Выйти в Мои райдеры",
    "editor.riderOperationsAriaLabel": "Операции с райдером",
    "editor.tabs.properties": "Properties",
    "editor.tabs.propertiesTitle": "Properties (E)",
    "editor.tabs.rider": "Райдер",
    "editor.tabs.inputList": "Input List",
    "editor.tabs.inputListTitle": "Input List (I)",
    "editor.tabs.outputList": "Output List",
    "editor.tabs.outputListTitle": "Output List (O)",
    "editor.tabs.gearList": "Gear List",
    "editor.riderTab.heading": "Параметры райдера",
    "editor.riderTab.titleLabel": "Название",
    "editor.riderTab.commentLabel": "Заметка",
    "editor.riderTab.stageWidthLabel": "Ширина (м)",
    "editor.riderTab.stageDepthLabel": "Глубина (м)",
    "editor.riderTab.useBorderLabel": "Ограничить границы сцены",
    "editor.riderTab.useBorderHint": "(выкл = разрешить объекты за пределами сцены — пульт, декор)",
    "editor.riderTab.contactLegend": "Контакты и группа",
    "editor.riderTab.moduleRider": "Райдер",
    "editor.riderTab.moduleStage": "Сцена",
    "editor.riderTab.moduleBand": "Группа",
    "editor.riderTab.moduleContact": "Контакт",
    "editor.riderTab.contactHint": "(заполняется из профиля; сохраняется с этим райдером)",
    "editor.riderTab.bandNameLabel": "Название группы",
    "editor.riderTab.bandLogoAlt": "Логотип группы",
    "editor.riderTab.bandLogoFileLabel": "Файл логотипа",
    "editor.riderTab.removeLogo": "Удалить логотип",
    "editor.riderTab.contactNameLabel": "Контактное лицо",
    "editor.riderTab.contactPhoneLabel": "Контактный телефон",
    "editor.riderTab.contactEmailLabel": "Контактный email",
    "editor.riderTab.saveDefaultsTitle":
        "Сохранить эти контакты как личные настройки по умолчанию — они будут подставляться в каждый новый райдер",
    "editor.riderTab.saveDefaultsLabel": "Сохранить как мои настройки",
    "editor.riderTab.riderTextLabel": "Текст райдера / Примечания",
    "editor.riderTab.savedDefaultsStatus": "Сохранено как ваши настройки по умолчанию.",
    "editor.riderTab.savedDefaultsFailed": "Не удалось сохранить настройки: {message}",
    "editor.listHint": "(весь райдер — перетащите строку для изменения порядка; Ch = позиция. Кликните строку для выбора объекта.)",
    "editor.reorderAriaLabel": "Изменить порядок",
    "editor.table.ch": "Канал",
    "editor.table.source": "Источник",
    "editor.table.type": "Тип",
    "editor.table.chName": "Имя канала",
    "editor.table.micDi": "Микрофон / DI",
    "editor.table.out": "OUT",
    "editor.table.comment": "Заметка",
    "editor.table.name": "Название",
    "editor.table.category": "Категория",
    "editor.table.owner": "Владелец",
    "editor.table.weight": "Вес",
    "editor.table.count": "Количество",
    "editor.inputTab.heading": "Input List (Входы)",
    "editor.inputTab.addButton": "Добавить входной канал",
    "editor.outputTab.heading": "Output List (Выходы)",
    "editor.outputTab.addButton": "Добавить выходную линию",
    "editor.gearTab.heading": "Gear List (Оборудование)",
    "editor.gearTab.hint": "(весь райдер — оборудование каждого объекта. Кликните строку для выбора объекта.)",
    "editor.gearTab.addButton": "Добавить позицию",
    "editor.params.closeTitle": "Снять выделение / Закрыть",
    "editor.params.emptyHint": "Выделите предмет на сцене, чтобы увидеть его свойства.",
    "editor.params.heading": "Выбранный объект",
    "editor.params.nameLabel": "Имя модели",
    "editor.params.nameHint": "(ключ каталога, только чтение)",
    "editor.params.titleLabel": "Заголовок",
    "editor.params.titleToSourceLabel": "Заголовок в Источник",
    "editor.params.commentLabel": "Заметка",
    "editor.params.parentLabel": "Родительский объект",
    "editor.params.xLabel": "X",
    "editor.params.yLabel": "Y",
    "editor.params.zLabel": "Z",
    "editor.params.zTitle": "Высота над сценой (м). Для декоративных объектов вне плоскости сцены — экран, шторы и т. п.",
    "editor.params.turnLabel": "Угол поворота°",
    "editor.params.lockPositionLabel": "Зафиксировать позицию",
    "editor.params.lockChildrenLabel": "Зафиксировать дочерние",
    "editor.params.structureLabel": "Конструкция",
    "editor.params.structureHint": "(на нее можно ставить другие объекты)",
    "editor.params.heightLabel": "Высота, м",
    "editor.params.heightHint": "(высота поверхности)",
    "editor.params.riserAcrossLabel": "Ширина, м",
    "editor.params.riserDeepLabel": "Глубина, м",
    "editor.params.riserHeightsLabel": "Быстрая высота, м",
    "editor.params.riserResizeLabel": "Двигать и менять размер на сцене",
    "presetMenu.riserTooltipHint": "двойной щелчок — изменить размер",
    "editor.params.riserResizeDoneLabel": "Готово",
    "editor.params.riserResizeHint": "Тяните предмет, чтобы сдвинуть, и ручки, чтобы изменить размер. Shift — без привязки, Enter или Esc — выйти.",
    "editor.params.stageMoveLabel": "Двигать на сцене",
    "editor.params.stageMoveHint": "Тяните его на сцене, чтобы сдвинуть. Shift — без привязки, Enter или Esc — выйти.",
    "editor.params.anchoredHint": "Закреплено — дважды щёлкните, чтобы двигать или менять размер",
    "editor.params.anchoredMoveHint": "Закреплено — дважды щёлкните, чтобы двигать",
    "editor.params.anchoredLockedHint": "Заблокировано — снимите «Зафиксировать позицию», чтобы двигать",
    "editor.params.snapToGridLabel": "Привязка к сетке",
    "editor.params.snapNeedsGridHint": "Привязка работает только при показанной сетке (кнопка сетки в верхней панели). Сетка скрыта — всё двигается свободно.",
    "editor.params.snapToGridHint": "Края встают на сетку того, из чего собран предмет: щит 0.5 м у подиума, кабинет у светодиодного экрана, стандартная секция у фермы. Выключено — предмет остаётся точно там, где вы его поставили.",
    "riser.handle.deep": "Потяните, чтобы изменить глубину",
    "riser.handle.across": "Потяните, чтобы изменить ширину",
    "riser.handle.corner": "Потяните, чтобы изменить ширину и глубину",
    "riser.handle.height": "Потяните, чтобы изменить высоту (шаг 0,2 м)",
    "riser.handle.dock": "Добавить такой же подиум с этой стороны",
    "riser.readout": "{across} × {deep} м · В {height} м",
    "stage.handle.deep": "Потяните, чтобы изменить глубину сцены",
    "stage.handle.across": "Потяните, чтобы изменить ширину сцены",
    "stage.handle.corner": "Потяните, чтобы изменить ширину и глубину сцены",
    "stage.readout": "Сцена {across} × {deep} м",
    "riser.status.docked": "Рядом поставлен такой же подиум.",
    "ledWall.handle.cols": "Потяните, чтобы добавить или убрать колонки кабинетов",
    "ledWall.handle.rows": "Потяните, чтобы добавить или убрать ряды кабинетов",
    "construction.led.cabinetLabel": "Кабинет, мм",
    "construction.led.cabinetCustom": "{w} × {h} (свой)",
    "construction.led.colsLabel": "Колонки",
    "construction.led.rowsLabel": "Ряды",
    "construction.led.pitchLabel": "Шаг пикселя, мм",
    "construction.led.mountLabel": "Крепление",
    "construction.led.mountGround": "Стек на полу",
    "construction.led.mountFlown": "Подвес",
    "construction.led.bottomLabel": "Нижний край, м",
    "construction.led.contentLabel": "На экране",
    "construction.led.contentOff": "Выключен (чёрный)",
    "construction.led.contentGrid": "Сетка кабинетов",
    "construction.led.contentBars": "Цветные полосы",
    "construction.led.contentLogo": "Заставка с логотипом",
    "construction.led.contentImage": "Картинка",
    "construction.led.contentMedia": "Медиа",
    "construction.led.chooseImage": "Выбрать картинку…",
    "construction.led.removeImage": "Убрать картинку",
    "construction.led.imageSet": "Картинка поставлена на LED-экран ({w} × {h} px).",
    "construction.led.imageTooBig": "Картинка слишком большая даже после уменьшения. Выберите поменьше.",
    "construction.led.imageUnreadable": "Этот файл не удалось прочитать как картинку.",
    "construction.led.imageRemoved": "Картинка убрана с LED-экрана.",
    "construction.led.mediaLabel": "Медиа",
    "construction.led.mediaLogo": "Логотип SoundCheckBox",
    "construction.led.mediaMascot": "Маскот",
    "construction.led.mediaIntro": "Заставка",
    "construction.led.mediaIntroPlain": "Заставка (без денег)",
    "construction.led.mediaTutorial": "Обучающий ролик",
    "construction.led.mediaCustomUpload": "Загружено: {name}",
    "construction.led.mediaCustomLink": "Ссылка: {host}",
    "construction.led.mediaUrlLabel": "Прямая ссылка (https)",
    "construction.led.mediaUrlPlaceholder": "https://…/video.mp4",
    "construction.led.mediaUrlUse": "Показать по ссылке",
    "construction.led.mediaUpload": "Загрузить видео или картинку…",
    "construction.led.mediaChecking": "Проверяю ссылку…",
    "construction.led.mediaUploading": "Загружаю…",
    "construction.led.mediaSet": "Экран показывает выбранное.",
    "construction.led.mediaProblemEmpty": "Вставьте ссылку на файл с видео или картинкой.",
    "construction.led.mediaProblemStreaming": "Страницы {site} нельзя показать на экране: {site} отдаёт видео только внутри своего проигрывателя. Возьмите прямую ссылку на файл (.mp4 или .webm) или загрузите файл.",
    "construction.led.mediaProblemNotHttps": "Ссылка должна начинаться с https://",
    "construction.led.mediaProblemCredentials": "Уберите логин и пароль из ссылки.",
    "construction.led.mediaProblemNotAddress": "Это не веб-адрес. Вставьте полную ссылку, которая начинается с https://",
    "construction.led.mediaProblemTooLong": "Ссылка слишком длинная.",
    "construction.led.mediaFailCors": "Этот сайт не разрешает показывать своё видео на других страницах.",
    "construction.led.mediaFailUnreachable": "Адрес не ответил. Проверьте ссылку и подключение.",
    "construction.led.mediaFailHttp": "Адрес ответил ошибкой ({status}): файла там нет или он не публичный.",
    "construction.led.mediaFailNotMedia": "По этому адресу веб-страница или список потока, а не файл с видео или картинкой. Нужна прямая ссылка на файл .mp4, .webm, .png, .jpg или .gif.",
    "construction.led.mediaFailFormat": "Браузер не смог воспроизвести этот файл. Подойдёт видео mp4 (H.264) или webm и картинка png, jpeg или gif.",
    "construction.led.mediaUploadForbidden": "Загружать медиа могут только администраторы.",
    "construction.led.mediaUploadType": "На экран можно поставить только файлы mp4, webm, png, jpeg и gif.",
    "construction.led.mediaUploadEmpty": "Файл пустой.",
    "construction.led.mediaUploadTooBig": "Файл слишком большой: видео — до {video} МБ, картинки — до {image} МБ.",
    "construction.led.mediaUploadFailed": "Не удалось загрузить. Попробуйте ещё раз.",
    "construction.led.derivedSize": "{size} м",
    "construction.led.derivedPx": "{px} px",
    "construction.led.derivedCount": "кабинетов: {count}",
    "construction.led.derivedLoad": "прибл. {kg} кг · прибл. {kw} кВт макс.",
    "construction.truss.typeLabel": "Тип",
    "construction.truss.typeLadder": "Плоская",
    "construction.truss.typeTriangle": "Треугольная",
    "construction.truss.typeBox": "Квадратная",
    "construction.truss.profileLabel": "Сечение, мм",
    "construction.truss.lengthLabel": "Длина, м",
    "construction.truss.trimLabel": "Высота низа (trim), м",
    "construction.truss.supportLabel": "Как держится",
    "construction.truss.supportFlown": "Подвес (лебёдки)",
    "construction.truss.supportFloor": "На полу",
    "construction.truss.supportGoalpost": "Ворота (две опоры)",
    "construction.truss.sections": "Секции: {sections}",
    "construction.truss.towers": "опоры 2 × {h} м",
    "construction.truss.longSpan": "длинный пролёт — сверьтесь с таблицей нагрузок",
    "editor.params.listsInputs": "Входы",
    "editor.params.listsOutputs": "Выходы",
    "editor.params.listsGear": "Гир",
    "editor.params.moduleObject": "Объект",
    "editor.params.modulePosition": "Положение",
    "editor.params.listPosition": "позиция",
    "editor.params.listPositions": "позиции",
    "editor.params.actionsLegend": "Действия с объектом",
    "editor.params.rotateHint":
        "Поворачивайте инструментом <strong>Повернуть</strong> в верхней панели или введите точный угол в поле <strong>Угол поворота</strong> выше.",
    "editor.params.addChildLabel": "Добавить дочерний",
    "editor.params.deleteObjectLabel": "Удалить объект",
    "editor.params.savePresetTitle": "Сохранить этот объект и его дочерние элементы как готовый пресет",
    "editor.params.savePresetLabel": "Сохранить как пресет",
    "editor.params.addInputLabel": "Добавить Input",
    "editor.params.addOutputLabel": "Добавить Output",
    "editor.params.linkOutputLabel": "Привязать к выходу",
    "editor.params.linkOutputTitle": "Привязать этот объект к существующей линии выхода или номеру канала",
    "editor.params.linkOutputDisabledTitle": "На сцене нет других выходов для привязки",
    "editor.params.addGearLabel": "Добавить оборудование",
    "editor.presetCategoriesAriaLabel": "Категории пресетов",
    "editor.exitConfirm.title": "Выйти без сохранения?",
    "editor.exitConfirm.body": "У вас есть несохраненные изменения в райдере. Если вы выйдете сейчас, они будут потеряны.",
    "editor.exitConfirm.saveAndLeave": "Сохранить и выйти",
    "editor.exitConfirm.leaveWithoutSaving": "Выйти без сохранения",

    // --- editor page behaviour (pages/editor-page.ts, JS-built status messages) ---------------------------
    "editor.status.gluedToGroup": "Присоединён к группе — теперь {members} объектов двигаются вместе.",
    "editor.status.glueNoTarget": "Под точкой сброса ничего нет — держите Shift над объектом, чтобы присоединиться к его группе.",
    "editor.status.glueFailed": "Не удалось присоединить к группе: {reason}",
    "editor.status.detached": "Вынут из группы — теперь двигается сам по себе.",
    "editor.status.detachNotGrouped": "Этот объект не в группе.",
    "editor.status.multiSelectCount": "Выбрано для группировки: {count} — отпустите Shift, чтобы завершить.",
    "editor.status.grouped": "Сгруппировано объектов: {count}.",
    "editor.status.groupFailed": "Не удалось сгруппировать: {reason}",
    "editor.status.attachCancelled": "Привязка отменена.",
    "editor.status.attachFailed": "Не удалось привязать: {reason}",
    "editor.status.attached": "Привязан {source} к {target}.",
    "editor.status.undo": "Отмена действия.",
    "editor.status.redo": "Повтор действия.",
    "editor.status.attachArmed": "Режим привязки активен — кликните по объекту, который станет родительским для {name} (Escape для отмены).",
    "editor.status.savingCopy": "Сохранение вашей копии…",
    "editor.status.savedAsCopy":
        "Сохранено как НОВЫЙ райдер — ваша копия. Оригинал принадлежит другому пользователю и остался без изменений.",
    "editor.status.saved": "Сохранено в {time}.",
    "editor.status.guestDraftRestored": "Ваша прошлая работа на месте — она хранится в этом браузере, пока вы не сохраните её в аккаунт.",
    "editor.status.guestDraftDiscarded":
      "Работа, сохранённая в этом браузере, не открылась безопасно, поэтому она была удалена, а не открыта повторно. Начинаем с нового пустого райдера.",
    "editor.status.guestDraftNotSaved":
      "Браузеру не удалось сохранить изменения здесь (возможно, хранилище переполнено). Не закрывайте эту вкладку либо войдите в аккаунт и сохраните работу.",
    "editor.draft.offer": "Несохранённые правки от {time}.",
    "editor.draft.continue": "Восстановить эти правки",
    "editor.draft.discard": "Оставить как есть",
    "editor.draft.close": "Закрыть — решу позже",
    "editor.naming.offer": "Сохранено. Райдер пока называется «New rider», и группа без названия — именно по ним вы будете его потом искать.",
    "editor.naming.name": "Назвать сейчас",
    "editor.naming.later": "Потом",
    "editor.draft.offerDiverged": "У вас есть несохранённые правки от {time}, но после этого райдер был снова сохранён на сервере. Если вернуть правки поверх него, более новая работа будет перезаписана.",
    "editor.draft.openAsCopy": "Открыть мои правки копией",
    "editor.draft.useSaved": "Взять сохранённую версию",
    "editor.draft.restored": "Ваши несохранённые правки вернулись. Нажмите «Сохранить», чтобы оставить их.",
    "editor.draft.restoredAsCopy": "Ваши правки открыты как новый несохранённый райдер. Сохранённый оригинал не тронут. Нажмите «Сохранить», чтобы оставить копию.",
    "editor.draft.notKept": "Браузер не смог сохранить запасную копию ваших правок (возможно, нет места). Нажмите «Сохранить», чтобы они не пропали при выходе из аккаунта.",
    "editor.draft.crashed": "Несохранённые правки, хранившиеся в этом браузере, не удалось безопасно открыть, поэтому они отброшены, а не открыты повторно.",
    "editor.status.modelsUnavailable": "Часть 3D-моделей не загрузилась — объекты показаны подписанными коробками. Работа не потеряна.",
    "editor.status.presetsUnavailable": "Каталог объектов не загрузился — рисовать можно, но меню пресетов пустое. Перезагрузите страницу, чтобы попробовать снова.",
    "editor.status.guestSaveNeedsAccount": "Войдите или зарегистрируйтесь, чтобы сохранить райдер — работа никуда не денется и перейдёт с вами.",
    "editor.status.guestSaveFailed": "Не удалось сохранить в аккаунт: {message}. Работа на месте — нажмите «Сохранить», чтобы попробовать снова.",
    "editor.status.saveFailed": "Ошибка сохранения: {message}",
    "editor.saveAs.heading": "Сохранить как новый райдер",
    "editor.saveAs.nameLabel": "Имя",
    "editor.saveAs.confirm": "Сохранить копию",
    "editor.saveAs.hint": "Открытый райдер останется как есть — сохранится отдельная копия под указанным именем.",
    "editor.saveAs.untitled": "Райдер без названия",
    "editor.status.savedAsNamedCopy": '«{title}» сохранён как новый райдер. Открытый райдер не изменился.',
    "editor.status.unpublished": "Снято с публикации — все публичные ссылки на этот райдер больше не работают.",
    "editor.status.published": "Опубликовано как v{version} — публичная ссылка: {url}",
    "editor.status.publishedNoPicture": "Опубликовано, но снимок плана не получился — опубликуйте ещё раз, не уходя с этой вкладки, и читатель увидит сцену, пока грузятся модели.",
    "editor.status.copiedSuffix": " (скопировано в буфер обмена)",
    "editor.status.publishFailed": "Ошибка публикации: {message}",
    "publishProgress.publishing": "Публикую райдер…",
    "publishProgress.drawing": "Опубликован как v{version}. Рисую план сцены для публичной страницы…",
    "publishProgress.done": "Опубликован как v{version} — публичная страница готова, план сцены на месте.",
    "publishProgress.published": "Опубликован как v{version} — публичная страница готова.",
    "publishProgress.noPicture": "Опубликован как v{version}, но план сцены нарисовать не удалось. Читатель увидит сцену, когда загрузятся модели. Опубликуйте ещё раз, не уходя с этой вкладки, чтобы добавить картинку.",
    "publishProgress.failed": "Публикация не удалась: {message}",
    "publishProgress.open": "Открыть публичную страницу",
    "editor.status.ioKeptNote": " Канал(ы) оставлены как пустые зарезервированные строки.",
    "editor.status.ioOptimizedNote": " Канал(ы) удалены, нумерация сдвинута.",
    "editor.status.deletedWithChildren": "Удален {title}; {count} дочерних объектов сохранены и перепривязаны на месте.",
    "editor.status.deleted": "Удален {title}.",
    "editor.status.deletedSubtree": "Удален {title} со всеми дочерними элементами.",
    "editor.status.rotated": "Повернут {name} на {deg}° ({mode}).",
    "editor.status.rotateModeObject": "только объект; дочерние удержаны",
    "editor.status.rotateModeSet": "весь комплект",
    "editor.status.moved": "Перемещен {name} в X {x}, Y {y}.",
    "editor.status.dropMissed": "Мимо сцены — попробуйте перетащить ближе к подиуму.",
    "editor.status.loadingRider": "Загрузка райдера…",
    "editor.status.loaded": "Загружен «{title}» — объектов на сцене: {count}.",
    "editor.status.loadedNotMineSuffix":
        " Этот райдер принадлежит другому пользователю — вы можете редактировать его, но Сохранение создаст вашу СОБСТВЕННУЮ копию.",
    "editor.status.loadFailed": "Ошибка загрузки: {message}",
    "editor.status.newRider": "Новый райдер (еще не сохранен).",

    // --- object-params panel behaviour (components/object-params-panel.ts) -------------------------------
    "objectParams.status.reparentFailed": "Не удалось сменить родителя: {reason}",
    "objectParams.status.moved": "Перемещен {name} в {location}.",
    "objectParams.status.locationNewParent": "новый родительский объект",
    "objectParams.status.locationTopLevel": "верхний уровень",
    "objectParams.status.lockedChildren": "Зафиксированы позиции всех дочерних элементов {name}.",
    "objectParams.status.reseated": "Переразмещено {n} объектов, стоящих на {name}.",
    "objectParams.status.addedInput": "Добавлен входной канал для {name}.",
    "objectParams.status.addedOutput": "Добавлен выход для {name}.",
    "objectParams.status.addedGear": "Добавлено оборудование для {name}.",
    "objectParams.status.addedChild": "«{childName}» добавлен в «{name}».",
    "objectParams.status.removed": "«{name}» удалён. Каналы оставшихся объектов не затронуты.",
    "objectParams.noParentOption": "(без родителя — верхний уровень)",

    // --- preset menu (components/preset-menu.ts) ----------------------------------------------------------
    "presetMenu.loading": "Загрузка пресетов…",
    "presetMenu.loadFailed": "Не удалось загрузить каталог объектов. Обновите страницу, чтобы попробовать снова.",
    "presetMenu.countSuffix": "({count})",
    "presetMenu.searchPlaceholder": "Поиск по каталогу",
    "presetMenu.searchNoMatch": "По запросу «{q}» ничего нет",
    "presetMenu.noMatch": "Нет пресетов, соответствующих фильтру.",
    "presetMenu.onlyMine": "Только мои",
    "presetMenu.added": 'Пресет "{name}" добавлен на сцену.',
    "presetMenu.removeFromCategory": "Убрать из «{category}»",
    "presetMenu.removedFromCategory": "«{name}» убран из «{category}». Сам пресет не тронут.",
    "presetMenu.removeFromCategoryFailed": "Не удалось убрать «{name}» из «{category}»: {message}",
    "presetMenu.deleteLastCategoryPrompt": "Это его единственная категория. Удаление уберёт пресет насовсем, восстановить нельзя. Удалить?",
    "presetMenu.deleteAlsoFromPrompt": "Пресет будет удалён насовсем — он пропадёт также из «{others}», восстановить нельзя. Удалить?",
    "presetMenu.deleting": 'Удаление пресета "{name}"…',
    "presetMenu.deleted": 'Удален пресет "{name}".',
    "presetMenu.deleteFailed": 'Не удалось удалить пресет "{name}": {message}',
    "presetMenu.uncategorizedCategory": "Без категории",
    "presetMenu.chooseCategoryPlaceholder": "— назначить категорию —",
    "presetMenu.assignedCategory": 'Пресет "{name}" назначен в категорию "{category}".',
    "presetMenu.assignCategoryFailed": 'Не удалось назначить категорию пресету "{name}": {message}',

    // --- Patch Editor (components/patch-editor-dialog.ts) — SCRUM-241 ---------------------------------------
    "patchEditor.title": "Patch Editor — Коммутация сцены",
    "patchEditor.subtitle": "Физическая маршрутизация для {count} аудио каналов по сценическим коробкам",
    "patchEditor.stageBoxesHeading": "Цифровые стейджбоксы и рэки",
    "patchEditor.routingTableHeading": "Таблица коммутации каналов",
    "patchEditor.colChannel": "Канал",
    "patchEditor.colSource": "Источник",
    "patchEditor.colSubSnake": "Сабснейк / Дропбокс",
    "patchEditor.colSocket": "Гнездо",
    "patchEditor.colStageBox": "Стейджбокс",
    "patchEditor.colBoxInput": "Вход рэка",
    "patchEditor.colCableLength": "Кабель",
    "patchEditor.cableSummaryHeading": "Кабельный лист (Спецификация в кейс)",
    "patchEditor.printSheet": "Печать таблицы патча",
    "patchEditor.close": "Закрыть",
    "patchEditor.done": "Готово",
    "topbar.patchEditor": "Патч",
    "topbar.patchEditor.disabledTooltip": "Patch Editor — Доступен в режиме Шоу / Тура, когда райдер привязан к площадке со стейджбоксами и пультами.",
    "topbar.patchEditor.activeTooltip": "Открыть Patch Editor — коммутация сцены (P)",

    // --- I/O keep-on-delete dialog (components/io-delete-dialog.ts) ----------------------------------------
    "ioDelete.heading": "Сохранить номера каналов или сдвинуть список?",
    "channelOverflow.heading": "Свободных каналов не хватает",
    "channelOverflow.summary": "«{preset}» требует {need} входных каналов. Свободно {free} ({slots}) — не хватает {short}.",
    "channelOverflow.movingLine": "CH {ch} — {source} / {name}",
    "channelOverflow.movingMore": "{lines} … и ещё {n}",
    "channelOverflow.nothingToMove": "Выше свободных каналов ничего нет — сдвигать нечего.",
    "channelOverflow.appendLabel": "Добавить в конец (CH {channels})",
    "channelOverflow.shiftLabel": "Сдвинуть с CH {from} на {n}",
    "channelOverflow.cancelled": "«{name}» не добавлен — вы отменили выбор по каналам.",
    "ioDelete.optimizeLabel": "Оптимизировать каналы",
    "ioDelete.keepLabel": "Оставить как есть",
    "ioDelete.rememberLabel": "Запомнить выбор (больше не спрашивать)",
    "ioDelete.inputChannelSingular": "{n} входной канал",
    "ioDelete.inputChannelPlural": "{n} входных(-ые) каналов(-а)",
    "ioDelete.outputChannelSingular": "{n} выходной канал",
    "ioDelete.outputChannelPlural": "{n} выходных(-ые) каналов(-а)",
    "ioDelete.summary": "Удаляемый объект содержит {parts}.",

    // --- row-edit dialog (components/row-edit-dialog.ts) — docs/V2_IO_KEEP_ON_DELETE.md §3c --------------
    "rowEdit.headingInput": "Редактировать входной канал",
    "rowEdit.headingOutput": "Редактировать выходную строку",
    "rowEdit.sourceLabel": "Источник",
    "rowEdit.chNameLabel": "Название канала",
    "rowEdit.typeLabel": "Тип",
    "rowEdit.commentLabel": "Комментарий",
    "rowEdit.lockedLabel": "Заблокировано",
    "rowEdit.chHashLabel": "Канал №",
    "rowEdit.lockedHint":
      "Канал заблокированной строки изменить нельзя. Снимите блокировку, чтобы переместить её, затем сохраните — разблокировка и перемещение выполняются вместе, за одно сохранение.",
    "rowEdit.lockedHintInput": "Номер заблокированного канала изменить нельзя. Снимите блокировку, чтобы переместить его, затем сохраните — разблокировка и перемещение выполняются вместе, за одно сохранение.",
    "rowEdit.linkedLabel": "Также подключены (общий микс)",
    "rowEdit.linkedHint": "Другие мониторы, питающиеся от этого же микса — например, два напольных монитора от одного посыла. На стейдж-плане у них тоже будет показан номер канала этой строки.",
    "rowEdit.linkedEmpty": "На сцене пока нет других мониторов.",
    "rowEdit.saveLabel": "Сохранить",
    "rowEdit.deleteChannel": "Удалить канал",
    "rowEdit.deleteLine": "Удалить строку",
    "rowEdit.errorInvalidChannel": "Канал должен быть числом не меньше 1.",
    "rowEdit.errorChannelTaken": "Канал {channel} уже занят другой строкой — выберите свободный номер.",
    "rowEdit.errorLineGone": "Эта строка больше не существует — закройте окно и попробуйте снова.",
    "rowEdit.errorChannelGone": "Этот канал больше не существует — закройте окно и попробуйте снова.",

    // --- link to existing output dialog (components/link-output-dialog.ts) ------------------
    "linkOutput.heading": "Привязать к существующему выходу",
    "linkOutput.currentlyLinkedLabel": "Текущие привязанные выходы:",
    "linkOutput.selectOutputLabel": "Выберите линию выхода:",
    "linkOutput.chooseOutputOption": "Выберите существующий выход...",
    "linkOutput.manualOption": "Ввести номер канала вручную...",
    "linkOutput.manualChannelLabel": "Номер канала:",
    "linkOutput.submitLabel": "Привязать",
    "linkOutput.unlinkButtonTitle": "Отвязать этот выход",
    "linkOutput.ownerSuffix": "владелец",
    "linkOutput.alreadyLinkedSuffix": "уже привязан",
    "linkOutput.errorSelectChannel": "Пожалуйста, выберите выход или введите корректный номер канала.",
    "linkOutput.error.invalidChannel": "Введите номер канала — 1 или больше.",
    "linkOutput.error.nodeNotFound": "Этого объекта больше нет на сцене. Закройте окно и выделите его заново.",
    "linkOutput.error.alreadyOwner": "Этот выход и так принадлежит объекту — привязывать нечего.",
    "linkOutput.error.channelNotFound": "На этом канале выхода пока нет. Сначала создайте его кнопкой «Add new Output».",
    "linkOutput.errorGeneric": "Не удалось привязать к выходу.",
    "linkOutput.status.linked": "Объект {name} привязан к выходу {channel}",
    "linkOutput.status.unlinked": "Объект {name} отвязан от выхода {channel}",

    // --- save-preset dialog (components/save-preset-dialog.ts) ---------------------------------------------
    "savePreset.heading": "Сохранить как пресет",
    "savePreset.nameLabel": "Название пресета",
    "savePreset.categoryLabel": "Категория",
    "savePreset.categoryRequiredHint": "(обязательно)",
    "savePreset.saveAsLabel": "Сохранить как",
    "savePreset.iconLegend": "Иконка",
    "savePreset.renderingHint": "Создание снимка объекта…",
    "savePreset.useRenderedIcon": "Использовать 3D-снимок",
    "savePreset.useOriginalIcon": "Использовать исходную картинку",
    "savePreset.clearUploaded": "Сбросить загруженный файл",
    "savePreset.submitLabel": "Сохранить пресет",
    "savePreset.usingUploadedImage": "Используется ваше загруженное изображение.",
    "savePreset.usingOriginalPresetIcon": "Используется оригинальная картинка пресета — можно переключить на 3D-снимок или загрузить файл.",
    "savePreset.autoGenerated": "Сгенерировано автоматически из 3D модели — загрузите файл для замены.",
    "savePreset.iconPreviewAlt": "Предпросмотр иконки пресета",
    "savePreset.chooseCategoryOption": "— выберите категорию —",
    "savePreset.newPresetOption": "Новый пресет",
    "savePreset.overwriteOption": "Перезаписать: {title}",
    "savePreset.sharedLibrarySuffix": " (общая библиотека)",
    "savePreset.confirmOverwriteButton": "Да, перезаписать",
    "savePreset.backToEdit": "Назад",
    "savePreset.overwriteWarning":
      'Перезапись заменит "{title}" — при каждой новой вставке будет использоваться обновлённая версия. Райдеры, где пресет уже использовался, сохранят свою копию с момента добавления и не изменятся.',
    "savePreset.overwriteWarningSharedNote": "Этот пресет входит в общую библиотеку — изменения увидят все пользователи.",
    "savePreset.subject": "{title} — объектов: {count}, сохраняется со всем дочерним деревом.",
    "savePreset.renderFailed": "Не удалось сгенерировать иконку — пресет будет сохранен без нее.",
    "savePreset.errorNodeGone": "Выбранный объект больше не существует — закройте окно и выберите объект заново.",
    "savePreset.errorNoCategory": "Выберите категорию — без нее пресет не появится в меню.",
    "savePreset.errorStaleTarget": "Вы больше не можете перезаписать этот пресет — переоткройте окно и попробуйте снова.",
    "savePreset.updated": 'Обновлен пресет "{title}" (id {id}) — изменения доступны в меню.',
    "savePreset.saved": 'Сохранен пресет "{title}" (id {id}) — он появился в меню пресетов.',
    "savePreset.saveFailed": "Не удалось сохранить пресет: {message}",
    "savePreset.imageReadFailed": "Не удалось прочитать изображение: {message}",

    // --- AI-ассистент (components/ai-assistant-dialog.ts) ---
    "ai.buttonTitle": "ИИ-ассистент — опишите изменение словами",
    "ai.buttonLabel": "ИИ",
    "ai.heading": "ИИ-ассистент",
    "ai.subheading": "Опишите изменение сцены обычными словами. Вы просмотрите каждую правку перед применением.",
    "ai.promptLabel": "Ваш запрос",
    "ai.promptPlaceholder": "напр. добавь барабанную установку в центре в глубине сцены и басовый комбик слева от неё",
    "ai.generate": "Сгенерировать",
    "ai.record": "Голосом",
    "ai.recordTitle": "Скажите запрос голосом (до 20 с)",
    "ai.recording": "Запись… нажмите микрофон, чтобы остановить.",
    "ai.stopRecording": "Остановить запись",
    "ai.micUnsupported": "Голосовой ввод не поддерживается в этом браузере.",
    "ai.micDenied": "Доступ к микрофону запрещён — разрешите его в браузере, чтобы говорить.",
    "ai.micEmpty": "Аудио не записалось — попробуйте ещё раз.",
    "ai.generating": "Думаю…",
    "ai.previewHeading": "Предлагаемые изменения",
    "ai.apply": "Применить изменения",
    "ai.discard": "Отменить",
    "ai.emptyPrompt": "Сначала опишите, что нужно изменить.",
    "ai.noChanges": "Ассистент не предложил изменений. Попробуйте переформулировать запрос.",
    "ai.notConfigured": "ИИ-ассистент ещё не подключён на этом сервере.",
    "ai.capReached": "Бесплатный лимит ИИ исчерпан. Добавьте свой ключ Gemini в профиле, чтобы продолжить пользоваться ассистентом.",
    "ai.providerError": "Сервис ИИ временно недоступен. Попробуйте ещё раз чуть позже.",
    "ai.invalid": "Ассистент не смог сформировать корректную правку для этого райдера. Попробуйте переформулировать.",
    "ai.invalidReference": "Ассистент сослался на объект или пресет, которого нет на этой сцене. Назовите его иначе или сначала добавьте.",
    "ai.someSkipped": "Не удалось применить изменений: {count} (ссылались на то, чего нет на сцене, или не поместились). Пропущено:",
    "ai.op.add": "Добавить объект",
    "ai.op.move": "Переместить объект",
    "ai.op.rotate": "Повернуть объект",
    "ai.op.delete": "Удалить объект",
    "ai.op.settings": "Изменить параметры сцены",
    "ai.op.unknown": "Операция",
    "ai.failed": "Не удалось связаться с ИИ-ассистентом. Проверьте соединение и повторите попытку.",
    "ai.applied": "Применено изменений от ассистента: {count}.",
    "ai.diff.addPreset": "Добавить {preset} в точку ({x}, {y}) м",
    "ai.diff.moveObject": "Переместить {object} в ({x}, {y}) м",
    "ai.diff.rotateObject": "Повернуть {object} на {deg}°",
    "ai.diff.deleteObject": "Удалить {object}",
    "ai.diff.deleteTree": "Удалить {object} и его дочерние объекты ({count})",
    "ai.diff.setRiderMeta": "Изменить параметры райдера: {fields}",
    "ai.diff.metaField.title": "название",
    "ai.diff.metaField.comment": "комментарий",
    "ai.diff.metaField.width": "ширина сцены",
    "ai.diff.metaField.length": "глубина сцены",

    // --- upload-object dialog (components/upload-object-dialog.ts) -----------------------------------------
    "uploadObject.heading": "Загрузить 3D объект",
    "uploadObject.hint": "Только для администраторов. Создает новый глобальный пресет из файла .glb.",
    "uploadObject.nameLabel": "Название",
    "uploadObject.modelLabel": "Файл модели (.glb)",
    "uploadObject.categoryLabel": "Категория",
    "uploadObject.iconLabel": "Иконка (опционально)",
    "uploadObject.heightLabel": "Высота, м",
    "uploadObject.structureLabel": "Является конструкцией (подиумом/ризером, на который ставятся объекты)",
    "uploadObject.submitLabel": "Загрузить и создать пресет",
    "uploadObject.errorNameRequired": "Укажите название.",
    "uploadObject.errorModelRequired": "Выберите файл модели .glb.",
    "uploadObject.errorNotGlb": "Модель должна быть в формате .glb.",
    "uploadObject.errorNoCategory": "Выберите категорию.",
    "uploadObject.uploading": "Загрузка…",
    "uploadObject.uploaded": 'Загружен "{name}" — теперь он доступен в библиотеке пресетов.',

    // --- list tables (components/list-tables.ts, editor/dom-utils.ts) --------------------------------------
    "dom.deleteLineTitle": "Удалить эту строку",
    "dom.editLineTitle": "Редактировать эту строку",
    "dom.editChannelTitle": "Редактировать этот канал",
    "dom.deleteChannelTitle": "Удалить этот канал",
    "listTables.unconnectedRowTitle":
        "Не подключено — объект этого канала был удален; номер удерживается. Удалите строку, чтобы освободить его.",
    "listTables.unconnectedChannelTitle": "Не подключено — объект этого канала был удален; номер удерживается. Удалите его, чтобы освободить номер.",
    "listTables.phantomTitle": "Фантомное питание (+48V) — нажмите для переключения",
    "listTables.dragHandleTitle":
        "Перетащите для изменения порядка — номер канала соответствует позиции в списке. Ctrl/Cmd- или Shift-клик для выделения нескольких строк.",
    "listTables.clearSelectionTitle": "Нажмите, чтобы снять выделение",
    "listTables.columnGripTitle": "{name} — потяните за край, чтобы изменить ширину; двойной щелчок по краю — по содержимому",
    "listTables.panelGripTitle": "Потяни, чтобы изменить ширину панели — это тот же край, что у самой панели",
    "listTables.noneOption": "(нет)",
    "listTables.categoryFromCatalogue": "Что это за вещь, говорит каталог. Поменять — значит поменять модель, а не подпись.",
    "listTables.categoryStale": "Строка ссылается на рубрику каталога {ref}, которой в каталоге больше нет. Выберите модель заново.",
    "listTables.gearUngrouped": "Вне комплектов",
    "listTables.selectionBadge": "Выбрано: {count} — потяните любую для перемещения группы",
    "listTables.linkLabel": "Связать",
    "listTables.unlinkLabel": "Разъединить",
    "listTables.pickModeLabel": "Выбрать несколько",
    "listTables.linkTitle": "Связать две выбранные строки в стереопару",
    "listTables.unlinkTitle": "Разъединить выбранную пару (имена остаются как есть)",
    "listTables.linkNeedTwo": "Выберите две соседние строки, чтобы связать их в стереопару",
    "listTables.linkNotAdjacent": "Связать можно только соседние строки (канал N и N+1)",
    "listTables.linkAlreadyPaired": "Одна из строк уже в паре — сначала разъедините её",
    "listTables.unlinkNothing": "Выберите связанную пару, чтобы разъединить её",
    "listTables.pairMarkTitle": "Стереопара — каналы {a} и {b}",
    "ioDelete.pairSummary": "Эта строка — половина стереопары. Вторая половина остаётся и становится обычной (моно) строкой.",
    "listTables.powerApprox": '≈{watts} Вт на ед. — приблизительное совпадение в каталоге ("{name}"), мощностные данные могут отличаться.',
    "listTables.powerExact": "{watts} Вт на ед., из каталога оборудования: {name}.",
    "listTables.powerLoading": "Загрузка данных о мощности…",
    "listTables.powerError": "Каталог оборудования недоступен — суммарная мощность не рассчитана.",
    "listTables.notFoundInCatalog": "Не найдено в каталоге: {names}",

    // --- power summary (editor/power.ts — shared by the Gear tab AND the printed rider) --------------------
    "power.noGearItems": "Оборудование еще не добавлено.",
    "power.totalLine": "Сцена / FOH: {backline} Вт · Акустические системы (PA): {pa} Вт",
    "power.fromLine": "— рассчитано для {resolved} из {items} поз.",
    "picker.catalogLoading": "Каталог загружается…",
    "picker.samePurpose": "то же назначение",
    "picker.family": "родственный",
    "picker.startTyping": "Начните печатать модель или производителя",
    "picker.keepTyped": "Оставить «{text}» как написано",
    "picker.classAnswers": "Модели, которые отвечают на «{name}»",
    "gear.notInCatalog": "нет в каталоге",
    "power.itemSingular": "{n} позиция",
    "power.itemPlural": "{n} позиций(-ии)",
    "power.zeroPowerSingular": "{items} не потребляет сетевое питание.",
    "power.zeroPowerPlural": "{items} не потребляют сетевое питание.",
    "power.unresolvedLine": "{items} не найдено в каталоге (не учитывается в расчете).",

    // --- print document (editor/print-rider.ts) -------------------------------------------------------------
    "printRider.noInputChannels": "Нет входных каналов.",
    "printRider.noOutputChannels": "Нет выходных каналов.",
    "printRider.noGearItems": "Нет списка оборудования.",
    "printRider.headers.ch": "Канал",
    "printRider.headers.v48": "48V",
    "printRider.headers.source": "Источник",
    "printRider.headers.micDi": "Микрофон / DI",
    "printRider.headers.type": "Тип",
    "printRider.headers.owner": "Владелец",
    "printRider.headers.comment": "Заметка",
    "printRider.headers.send": "Назначение / Send",
    "printRider.headers.category": "Категория",
    "printRider.headers.name": "Название",
    "printRider.headers.count": "Кол-во",
    "printRider.headers.belongsTo": "Относится к",
    "printRider.headers.offer": "OFFER",
    "printRider.gear.bandBrings": "Привозит коллектив — заказывать не надо",
    "printRider.gear.allCables": "Все необходимые кабели для подключения оборудования по райдеру",
    "printRider.gear.bandNote": "Это оборудование будет на площадке — коллектив везёт его сам. Прокату заказывать не нужно.",
    "printRider.gear.ungrouped": "Вне комплектов",
    "printRider.gear.noCategory": "Без рубрики",
    "gearList.section.pa": "P.A.",
    "gearList.section.amplification": "Усиление",
    "gearList.section.mixing": "Микшерная система",
    "gearList.section.backline": "Бэклайн",
    "gearList.section.monitoring": "Мониторинг",
    "gearList.section.instruments": "Инструменты",
    "gearList.section.mics": "Микрофоны и DI",
    "gearList.section.stands": "Стойки",
    "gearList.section.stage": "Сценические конструкции",
    "gearList.section.power": "Электропитание",
    "gearList.section.wire": "Кабели",
    "gearList.section.consumables": "Расходники",
    "gearList.standFor.microphone": "Микрофонные стойки",
    "gearList.standFor.guitar-bass": "Подставки для гитар и басов",
    "gearList.standFor.keyboard": "Подставки для клавишных",
    "gearList.standFor.wind": "Подставки для духовых",
    "gearList.standFor.drums-percussion": "Стойки для барабанов и перкуссии",
    "gearList.standFor.speaker": "Стойки для акустических систем",
    "gearList.standFor.sheet-music-other": "Пюпитры и прочее",
    "gearList.drumKit": "Ударная установка",
    "gearList.otherInstruments": "Другие инструменты",
    "gearList.drumKitMics": "Микрофоны ударной установки",
    "gearList.otherMics": "Остальные микрофоны и DI",
    "publicViewer.gear.eachFor": "Каждый из {n} — для чего он нужен",
    "gearList.bandBlock": "Привозит коллектив",
    "gearList.where.standalone": "Отдельная позиция",
    "gearList.where.standaloneMany": "отдельных позиций: {count}",
    "gearList.where.acrossStage": "мест на сцене: {count}",
    "gearList.alsoUnder": "ещё в разделе «{section}»: {count}",
    "gearList.derivedFrom": "из инпут-листа, кан. {channels} · {source} — меняется в инпут-листе",
    "gearList.groupCount": "{lines} поз. · {items} шт.",
    "gearList.groupCountOne": "1 поз. · {items} шт.",
    "gearList.unstated.pa": "В райдере не указано.",
    "gearList.unstated.mixing": "В райдере не указано — рассчитано по инпут- и аутпут-листу.",
    "gearList.unstated.band": "Коллектив везёт свою — см. в конце списка.",
    "gearList.mixing.need": "Инпут-лист: {inputs}. Аутпут-лист: {outputs}.",
    "gearList.mixing.inputs.one": "{n} вход",
    "gearList.mixing.inputs.few": "{n} входа",
    "gearList.mixing.inputs.many": "{n} входов",
    "gearList.mixing.inputs.other": "{n} входов",
    "gearList.mixing.outputs.one": "{n} выход",
    "gearList.mixing.outputs.few": "{n} выхода",
    "gearList.mixing.outputs.many": "{n} выходов",
    "gearList.mixing.outputs.other": "{n} выходов",
    "gearList.mixing.modelUnstated": "Модель не указана.",
    "gearList.mixing.modelUnstatedBare": "модель не указана",
    "gearList.mixing.requirement": "Микшерная система ёмкостью не менее {inputs} / {outputs}: {picks}.",
    "gearList.mixing.monitorRequirement": "Мониторный пульт ёмкостью не менее {inputs} / {outputs}: {picks}.",
    "gearList.mixing.pickBrand": "любой пульт {brand}",
    "mixing.line.title": "Микшерная система",
    "mixing.monitorDesk.title": "Мониторный пульт",
    "mixing.monitorConsole.title": "Мониторный пульт",
    "mixing.monitor.fromFoh": "С FOH",
    "mixing.monitor.separate": "Отдельный пульт",
    "mixing.need.short": "≥{inputs} вх / {outputs} вых",
    "mixing.notSpecified": "Модель не указана",
    "mixing.line.tooltip": "{title}: {picks} — нажмите, чтобы изменить",
    "mixing.dialog.need": "Не менее {inputs} входов / {outputs} выходов (по спискам)",
    "mixing.dialog.close": "Закрыть",
    "mixing.dialog.remove": "Убрать {name}",
    "mixing.dialog.done": "Готово",
    "mixing.dialog.digital": "Цифровые",
    "mixing.dialog.analogue": "Аналоговые",
    "mixing.dialog.brandsHint": "Выберите марку. Подойдёт любой её пульт, который тянет шоу, или откройте марку и выберите конкретные пульты.",
    "mixing.dialog.back": "‹ Марки",
    "mixing.dialog.anyBrand": "Любой пульт {brand}",
    "mixing.dialog.anyBrandMeta": "все, что тянут шоу: {fit} из {total}",
    "mixing.tier.senior": "Старшие",
    "mixing.tier.mid": "Средние",
    "mixing.tier.entry": "Младшие",
    "mixing.desk.figures": "{inputs} вх / {outputs} вых",
    "mixing.desk.unknown": "?",
    "mixing.desk.notStated": "ёмкость не указана",
    "mixing.desk.tooSmall": "мал для этого райдера",
    "mixing.desk.discontinued": "снят с производства",
    "mixing.pick.brand": "Любой {brand}",
    "gearList.bySection": "По разделам",
    "gearList.byKit": "По комплектам",
    "gearList.groupingLabel": "Группировка",
    "gearList.collapseAll": "Свернуть все",
    "gearList.expandAll": "Развернуть все",
    "printRider.gear.orderSummary": "К поставке: позиций — {lines}, всего {items} шт., разделов — {sections}.",
    "printRider.gear.orderSummaryBand": "Ещё позиций — {lines}: их коллектив везёт сам, они в конце списка и не заказываются.",
    "printRider.gear.youOffer": "Вы предлагаете:",
    "printRider.headers.offerHint": "✓ как просили, или эквивалент",
    "printRider.offer.date": "Дата",
    "printRider.offer.city": "Город",
    "printRider.offer.venue": "Площадка",
    "printRider.offer.company": "Прокатная компания",
    "printRider.offer.answeredBy": "Кто отвечает",
    "printRider.offer.weAsk": "Мы просим",
    "printRider.offer.youOffer": "Вы предлагаете",
    "printRider.gear.derivedFrom": "из инпут-листа, кан. {channels}",
    "printRider.gear.summaryLabel": "Итог",
    "printRider.gear.summaryOr": "или:",
    "printRider.gear.inDetail": "Подробно",
    "printRider.gear.sum.wedgeMixes": "Линии напольных мониторов: {count}",
    "printRider.gear.sum.iemMixes": "Инейр-миксы: {count}",
    "printRider.gear.sum.otherOutputs": "Прочие выходы: {count}",
    "printRider.gear.sum.microphones": "Микрофоны: {count}",
    "printRider.gear.sum.microphonesWireless": "Микрофоны: {count}, из них радио: {wireless}",
    "printRider.gear.sum.diBoxes": "DI-боксы: {count}",
    "printRider.gear.sum.drumKit": "Ударная установка, предметов: {pieces}",
    "printRider.gear.sum.more": "и ещё {count}",
    "printRider.offer.heading": "На этот райдер отвечают в самом документе",
    "printRider.offer.howTitle": "Как отвечать.",
    "printRider.offer.howTick": "галочка — ровно как просили",
    "printRider.offer.howEq": "строка — предлагаемый эквивалент",
    "printRider.offer.howSummary": "Каждый раздел оборудования начинается с итога: поставьте галочку, если весь раздел как просили, и отвечайте построчно только там, где у вас иначе.",
    "printRider.offer.howNo": "Чего не можете предоставить — напишите «нет» и почему. Причина — это ответ, молчание — нет.",
    "printRider.offer.stageAsk": "Сцена {width} × {length} м.",
    "printRider.offer.signatures": "Подписи",
    "printRider.offer.preparedBy": "Оффер подготовил (прокат / площадка)",
    "printRider.offer.acceptedBy": "Принято со стороны коллектива",
    "printRider.offer.signDate": "Дата",
    "printRider.offer.answerOk": "OK",
    "printRider.offer.answerSub": "Замена: {model}",
    "printRider.offer.answerBandCarried": "Привозит коллектив",
    "printRider.offer.answerNa": "Нет в наличии: {reason}",
    "printRider.offer.answerVenue": "Есть на площадке",
    "printRider.offer.answerVenueNote": "Есть на площадке: {note}",
    "printRider.offer.answeredHeading": "Оффер от {supplier} · {status} · ответы v{round}",
    "printRider.footer.offerFor": "Оффер для: ______________________",
    "printRider.footer.page": "Лист {page} из {pages}",
    "printRider.publicLinkMissing":
        'Публичная ссылка: еще не опубликован — нажмите "Опубликовать райдер" в верхней панели редактора, чтобы получить QR-код.',
    "printRider.publicLinkLabel": "Публичная ссылка (сканируйте или перейдите) — только чтение — v{version}",
    "printRider.qrUnavailable": "QR-код недоступен (ссылка слишком длинная) — используйте URL выше.",
    "printRider.qrAriaLabel": "QR-код со ссылкой на публичную страницу этого райдера",
    "printRider.untitledRider": "Райдер без названия",
    "printRider.stagePlotUnavailable": "Схема сцены недоступна.",
    "printRider.stagePlotPending": "Снимок сцены собирается…",
    "printRider.stagePlanPending": "План сцены собирается…",
    "printRider.stagePlotAlt": "Схема сцены",
    "printRider.sections.stagePlan": "План сцены — вид сверху",
    "printRider.stagePlanAlt": "План сцены, вид сверху",
    "printRider.stagePlanUnavailable": "План сцены недоступен.",
    "printRider.contactLabel": "Контакт: {name}",
    "printRider.telLabel": "Тел: {phone}",
    "printRider.emailLabel": "Email: {email}",
    "printRider.bandLogoAlt": "Логотип группы",
    "printRider.footerPage": "Стр. {page} из {pages}",
    "printRider.docTitle": "{heading} — райдер",
    "printRider.metaBrand": "Технический райдер SoundCheckBox",
    "printRider.idLabel": "ID: {id}",
    "printRider.unsavedId": "(не сохранен)",
    "printRider.stageSize": "Сцена: {width} × {length} м",
    "printRider.sections.stagePlot": "Схема сцены",
    "printRider.sections.riderNotes": "Заметки к райдеру",
    "printRider.sections.inputList": "Входной лист (Input List)",
    "printRider.sections.outputList": "Выходной лист (Output List)",
    "printRider.sections.gearList": "Список оборудования (Gear List)",
    // --- print settings panel (components/print-options-dialog.ts, SCRUM-96) ---
    "printVariant.heading": "Что печатаем?",
  "printVariant.simpleName": "Simple View",
  "printVariant.simpleNote": "Одна альбомная страница: план сцены, под ним списки входов и выходов.",
  "printVariant.techName": "Tech stage plot",
  "printVariant.techNote": "Одна страница, чёрно-белый план — для технической команды",
  "printVariant.bothName": "Обе страницы",
  "printVariant.bothNote": "Две страницы: чёрно-белая для техников, цветная для артиста",
  "printVariant.fullName": "Печатать всё",
  "printVariant.fullNote": "Полный райдер, каждый раздел на отдельном листе.",
  "print.fileNameSimple": "{title} — Simple View",
  "print.fileNameTech": "{title} — Tech Plot",
  "print.fileNameBoth": "{title} — Tech Plot + Simple View",
  "print.fileNameFull": "{title} — Full Details",
  "simpleView.captionSuffix": "Интерактивный план сцены и предложение по этому райдеру — на soundcheckbox.com",
  "simpleView.labelTech": "Tech stage plot",
  "simpleView.labelColour": "Simple view",
  "simpleView.captionUnpublished": "Неопубликованный райдер — {site}",
  "editor.documentTitle": "{title} — SoundCheckBox",
  "editor.documentTitleUntitled": "Райдер без названия",
  "simpleView.plotUnavailable": "План сцены недоступен",
  "simpleView.overflow": "Часть строк не поместилась на лист.",
  "simpleView.textClipped": "Остальной текст райдера — в полной печати райдера и на его публичной странице.",
  "printOptions.heading": "Параметры печати",
    "printOptions.openTitle": "Параметры печати…",
    "printOptions.hint": "Выберите, что попадёт на страницу. Оставьте заголовок столбца пустым — останется стандартный.",
    "printOptions.presetFull": "Полный райдер",
    "printOptions.presetOnePage": "Одна страница (альбомная)",
    "printOptions.gearLegend": "Список оборудования",
    "printOptions.gearByCategory": "Группировать по категориям",
    "printOptions.gearByKit": "Группировать по комплектам",
    "printOptions.pageLegend": "Страница",
    "printOptions.pageBreaks": "Каждый раздел с новой страницы",
    "printOptions.landscapePage": "Альбомная страница",
    "printOptions.alwaysLandscape": "Всегда альбомная, на всю страницу",
    "printOptions.onCover": "На обложке",
    "printOptions.coverInfo": "Информация",
    "printOptions.coverEditContacts": "Изменить",
    "printOptions.coverSaveContacts": "Сохранить",
    "printOptions.coverBandLink": "Ссылка группы",
    "printOptions.coverOff": "не печатается",
    "printOptions.coverMissing": "Не заполнено: {fields}",
    "printOptions.coverMissingShort": "не заполнено: {count}",
    "printOptions.sectionsLegend": "Разделы",
    "printOptions.lookLegend": "Оформление",
    "printOptions.coverLegend": "Обложка",
    "printOptions.cover": "Печатать обложку",
    "printOptions.coverLogoSize": "Размер логотипа",
    "printOptions.coverTextSize": "Размер надписей",
    "printOptions.coverLogoFile": "Логотип",
    "printOptions.coverNoLogo": "не загружен",
    "printOptions.coverLogoUpload": "Загрузить",
    "printOptions.coverLogoReplace": "Заменить",
    "printOptions.coverLogoClear": "Убрать",
    "printOptions.coverLogoFromRider": "Логотип хранится в райдере — он же на публичной странице и в блоке контактов",
    "printOptions.coverCheckEmpty": "не заполнено",
    "printOptions.coverCheck.logo": "Логотип",
    "printOptions.coverCheck.band": "Группа",
    "printOptions.coverCheck.rider": "Райдер",
    "printOptions.coverCheck.contact": "Контакты",
    "printOptions.coverCheck.link": "Ссылка группы",
    "printOptions.coverCheck.qr": "QR публичной ссылки",
    "printOptions.coverLogo": "Логотип",
    "printOptions.coverText": "Надписи",
    "printOptions.align.left": "Слева",
    "printOptions.align.center": "По центру",
    "printOptions.align.right": "Справа",
    "printOptions.previewTitle": "Предпросмотр",
    "printOptions.previewBuilding": "Собираю лист…",
    "printOptions.previewFailed": "Предпросмотр недоступен",
    "printOptions.style.plain": "Простой",
    "printOptions.style.classical": "Классика",
    "printOptions.style.jazz": "Джаз",
    "printOptions.style.rock": "Рок",
    "printOptions.style.metal": "Метал",
    "printOptions.style.disco": "Диско",
    "printOptions.palette.mono": "Чёрно-белая",
    "printOptions.palette.graphite": "Графит",
    "printOptions.palette.blue": "Синяя",
    "printOptions.palette.red": "Красная",
    "printOptions.palette.amber": "Янтарная",
    "printOptions.palette.violet": "Пурпурная",
    "printOptions.inputColumnsLegend": "Столбцы инпут-листа",
    "printOptions.outputColumnsLegend": "Столбцы аутпут-листа",
    "printOptions.confirm": "Печать",
    "printOptions.savePdf": "Сохранить PDF",
    "printOptions.savedPdf": "PDF сохранён.",
    "printOptions.section.contact": "Группа и контакты",
    "printOptions.section.publicLink": "Публичная ссылка и QR",
    "printOptions.section.powerSummary": "Суммарная мощность",
    "printOptions.section.stage3d": "Stage 3D view (in color)",
    "printOptions.section.techTopView": "Stage plot tech top view",

    // --- wysiwyg toolbar (components/wysiwyg-editor.ts) --------------------------------------------------
    "wysiwyg.bold": "Жирный",
    "wysiwyg.italic": "Курсив",
    "wysiwyg.underline": "Подчеркнутый",
    "wysiwyg.bulletedList": "Маркированный список",
    "wysiwyg.numberedList": "Нумерованный список",
    "wysiwyg.clearFormatting": "Очистить форматирование",
    "wysiwyg.boldLabel": "Ж",
    "wysiwyg.italicLabel": "К",
    "wysiwyg.underlineLabel": "Ч",
    "wysiwyg.bulletedListLabel": "• Список",
    "wysiwyg.numberedListLabel": "1. Список",
    "wysiwyg.clearFormattingLabel": "⌫ Очистить",

    // --- main.ts fatal startup overlay --------------------------------------------------------------------
    "main.fatal.heading": "Не удалось запустить SoundCheckBox",
    "main.fatal.hint": "Отправьте этот текст в службу поддержки — он поможет точно определить проблему.",
    "main.fatal.userAgentLabel": "User agent: {ua}",

    // --- editor tour & cheatsheet (components/editor-tour.ts) ---------------------------------------------
    "tour.buttonTitle": "Обучающий тур и справка (?)",
    "tour.buttonLabel": "Обучение",
    "tour.stepBadge": "Шаг {current} из {total}",
    "tour.closeAriaLabel": "Закрыть",
    "tour.prev": "← Назад",
    "tour.next": "Далее →",
    "tour.finish": "Завершить",
    "tour.cheatSheetButton": "Шпаргалка",
    "tour.cheatSheetButtonTitle": "Открыть полную шпаргалку по клавишам и модификаторам",
    "tour.cheatSheetTitle": "Горячие клавиши и модификаторы редактора",
    "tour.startTourButton": "Запустить тур",
    "tour.closeSheetButton": "Закрыть",

    "tour.steps.stageSize.title": "1. Измените размер сцены",
    "tour.steps.stageSize.desc": "Дважды щёлкните по полу сцены (на сенсорном экране — двойное касание). Тяните ручки по краям и углам, чтобы задать ширину и глубину сцены; размер в метрах — слева сверху. Затем <b>Готово</b> или <b>Enter</b>.",
    "tour.steps.addObject.title": "2. Добавьте участников и оборудование",
    "tour.steps.addObject.desc": "Выберите вкладку внизу (<b>members</b> — музыканты, <b>Drums &amp; Perc</b>, <b>mic &amp; DI</b>, <b>monitors</b>, <b>backline</b>…). Нажмите на пресет или перетащите его на сцену, затем поставьте на место.",
    "tour.steps.addObject.iem": "Некоторые музыканты предпочитают инейры.",
    "tour.steps.addObject.outputs": "<b>Output List</b> пересчитается автоматически.",
    "tour.steps.members.title": "3. Участники и их оборудование",
    "tour.steps.members.desc": "Участник — основа пресета: с ним приходят его инструменты, микрофоны и DI. Но иногда удобнее видеть на сцене только необходимое оборудование: с зажатым <b>Alt</b> щёлкните по участнику и нажмите <b>Delete</b> — оборудование останется.",
    "tour.steps.arrange.title": "4. Расставьте оборудование",
    "tour.steps.arrange.desc": "Перетаскивайте предметы на место. <b>Повернуть</b> включает кольцо — потяните его, чтобы повернуть выбранное. <b>Привязать объект</b>, затем щелчок по подиуму или стойке крепит предмет к ним, и дальше они двигаются вместе. <b>Вся стопка</b> / <b>Один предмет</b> — что берёт щелчок. Приёмы — в <b>Шпаргалке</b>. Взаимное расположение оборудования и сценических конструкций иногда удобнее поправить в виде сверху — <b>Вид сверху</b>.",
    "tour.steps.channels.title": "5. Input List и Output List",
    "tour.steps.channels.desc": "<b>Input List</b> и <b>Output List</b> формируются автоматически из того, что стоит на сцене, — просто впишите имена музыкантов в столбец <b>Источник</b>. Чтобы сменить <b>Канал</b>, перетащите строку. Дайте адреса миксам: в <b>Источник</b> впишите, кому поставлен каждый монитор.",
    "tour.steps.micDi.title": "6. Микрофоны и DI",
    "tour.steps.micDi.desc": "Микрофоны и DI приходят с пресетами. Нажмите на ячейку <b>Микрофон / DI</b> в строке и выберите в выпадающем списке те, что предпочитаете.",
    "tour.steps.planSheet.title": "7. Проверьте чертёж",
    "tour.steps.planSheet.desc": "Переключитесь на <b>Чертёж</b> и проверьте, как ваш райдер выглядит в виде чертежа, — так его увидят техники на сцене. Предметы можно двигать и здесь.",
    "tour.steps.riderFill.title": "8. Заполните райдер и сохраните его",
    "tour.steps.riderFill.desc": "На вкладке <b>Райдер</b> справа: напишите <b>Текст райдера / Примечания</b>, впишите <b>Название</b> райдера и <b>Название группы</b>, добавьте <b>Логотип группы</b>. Затем нажмите вверху <b>Сохранить райдер в базу данных</b>.",
    "tour.steps.publishPrint.title": "9. Публикация и печать",
    "tour.steps.publishPrint.desc": "Когда райдер сохранён, <b>Опубликовать райдер</b> делает ссылку только для просмотра для площадки и копирует её. <b>PDF</b> спрашивает <b>Что печатаем?</b>: <b>Simple View</b>, <b>Tech stage plot</b> или <b>Обе страницы</b>; <b>Печатать всё</b> открывает <b>Параметры печати</b> с предпросмотром.",
    "tour.end.title": "Очистить сцену или продолжить?",
    "tour.end.desc": "Тур расставил оборудование на сцене. Очистить её или продолжить работу с этой сценой?",
    "tour.end.clean": "Очистить сцену",
    "tour.end.keep": "Продолжить с этой сценой",
    "tour.banner.text": "Впервые здесь? Короткий тур: программа сама покажет каждый шаг на сцене.",
    "tour.banner.start": "Начать тур",
    "tour.banner.close": "Закрыть",

    "tour.cs.sectionNav": "Навигация в 3D",
    "tour.cs.dragOrbit": "Вращение камеры вокруг сцены",
    "tour.cs.dragPan": "Перемещение в плоскости сцены",
    "tour.cs.zoom": "Приближение / отдаление",
    "tour.cs.topView": "Переключение «Вид сверху / 3D»",

    "tour.cs.sectionModifiers": "Жесты и модификаторы",
    "tour.cs.clickDefault": "Выбор и перетаскивание группы или подиума целиком",
    "tour.cs.altClick": "Выбор единичного объекта на подиуме или в сете",
    "tour.cs.altDrag": "Перемещение одного объекта без сдвига группы",
    "tour.cs.shiftGlue": "Приклеивание перетаскиваемого объекта к цели под курсором",
    "tour.cs.altShiftDetach": "Отклеивание объекта из группы на месте",
    "tour.cs.rotateGizmo": "Вращение группы (с Alt — поворот одного объекта на месте)",

    "tour.cs.sectionObjectOps": "Операции над объектами",
    "tour.cs.opProperties": "Параметры объекта и аудио-каналы",
    "tour.cs.opRotate": "Включение интерактивного кольца вращения (Gizmo)",
    "tour.cs.opAttach": "Привязать выбранный объект к другому",
    "tour.cs.opSavePreset": "Сохранить выбранный сет/объект в пресет",
    "tour.cs.opDelete": "Удалить только этот объект (дети сохраняются)",
    "tour.cs.opDeleteTree": "Удалить объект вместе со всеми дочерними элементами",

    "tour.cs.sectionHotkeys": "Горячие клавиши",
    "tour.cs.keyProperties": "Показать / скрыть свойства объекта",
    "tour.cs.keyRotate": "Включить / выключить кольцо вращения",
    "tour.cs.keyInputList": "Открыть / закрыть Input List",
    "tour.cs.keyOutputList": "Открыть / закрыть Output List",
    "tour.cs.keyUndo": "Отменить действие",
    "tour.cs.keyRedo": "Повторить действие",
    "tour.cs.keySave": "Сохранить райдер",
    "tour.cs.keyEscape": "Снять выделение / Закрыть окно",
    "sideNav.shows": "Шоу",
    "shows.pageTitle": "Шоу",
    "shows.tab.inbox": "Входящие",
    "shows.tab.calendar": "Календарь",
    "shows.tabsLabel": "Разделы шоу",
    "shows.tab.list": "Шоу",
    "shows.list.label": "Все шоу",
    "shows.list.col.date": "Дата",
    "shows.list.col.band": "Группа",
    "shows.list.col.venue": "Площадка",
    "shows.list.col.city": "Город",
    "shows.list.col.rental": "Прокат",
    "shows.list.col.status": "Статус",
    "shows.list.empty": "Шоу пока нет.",
    "shows.list.emptyFiltered": "На этот выбор шоу нет.",
    "shows.list.rentalOne": "1 оффер",
    "shows.list.rentalMany": "Офферов: {n}",
    "shows.list.rentalNone": "Офферов пока нет",
    "shows.list.rentalYou": "Вы",
    "shows.list.dateOpen": "Дата ещё не назначена",
    "shows.list.state.sketch": "Набросок",
    "shows.mcal.label": "Календарь шоу",
    "shows.mcal.prev": "Предыдущий месяц",
    "shows.mcal.next": "Следующий месяц",
    "shows.mcal.showAll": "Показать все",
    "shows.mcal.filterDay": "Шоу на {day}",
    "shows.mcal.filterMonth": "Шоу в {month}",
    "shows.mcal.today": "сегодня",
    "shows.loadFailed": "Не удалось загрузить шоу: {error}",
    "shows.inbox.empty": "Сейчас от вас ничего не требуется.",
    "shows.inbox.listLabel": "Что требует вашего внимания",
    "shows.inbox.unknownWho": "Поставщик",
    "shows.inbox.approvalNew": "{who} прислал(а) предложение для «{subject}» ({when}). Оно ждёт вашего утверждения.",
    "shows.inbox.approvalAgain": "{who} снова прислал(а) предложение для «{subject}» ({when}). Оно ждёт вашего утверждения.",
    "shows.inbox.newOffer": "{who} прислал(а) предложение для «{subject}» ({when}).",
    "shows.inbox.reconfirm": "Райдер изменился (v{from} → v{to}). Подтвердите своё предложение для «{subject}» ({when}) заново.",
    "shows.inbox.declined": "Ваше предложение для «{subject}» ({when}) отклонено.",
    "shows.inbox.declinedReason": "Причина: {reason}",
    "shows.inbox.riderRequest": "Для «{subject}» ({when}) запрошен райдер.",
    "shows.inbox.open": "Открыть",
    "shows.inbox.dateOpen": "дата ещё не назначена",
    "shows.inbox.received": "Получено {at}",
    "shows.inbox.new": "Новое",
    "sideNav.unreadCount": "{n} новых",
    "shows.cal.month": "Месяц",
    "shows.cal.week": "Неделя",
    "shows.cal.list": "Список",
    "shows.cal.today": "Сегодня",
    "shows.cal.prev": "Назад",
    "shows.cal.next": "Вперёд",
    "shows.cal.noEvents": "В этом периоде шоу нет",
    "shows.cal.waiting": "Ждут даты",
    "shows.cal.waitingHint": "Шоу без даты не стоят на сетке.",
    "shows.cal.waitingEmpty": "Никто не ждёт даты.",
    "shows.cal.sketch": "Набросок",
    "shows.cal.untitled": "Шоу без названия",
    "shows.feed.title": "Подписаться в своём календаре",
    "shows.feed.hint": "Google, Apple и Outlook принимают этот адрес через «подписаться по URL».",
    "shows.feed.hidden": "Ссылка включена. Из соображений безопасности она показывается только при создании — перевыпустите её, чтобы получить новую.",
    "shows.feed.addressLabel": "Ваш личный адрес календаря",
    "shows.feed.create": "Создать ссылку",
    "shows.feed.rotate": "Перевыпустить",
    "shows.feed.rotateConfirm": "Нажмите ещё раз: старая ссылка перестанет работать",
    "shows.feed.turnOff": "Выключить",
    "shows.feed.turnOffConfirm": "Нажмите ещё раз, чтобы выключить",
    "shows.feed.failed": "Не удалось обновить ссылку календаря: {error}",
    "shows.detail.back": "Шоу",
    "shows.detail.loadFailed": "Не удалось открыть это шоу: {error}",
    "shows.detail.state.open": "Открыто",
    "shows.detail.state.waiting": "Ждёт предложений",
    "shows.detail.state.offers_in": "Предложения получены",
    "shows.detail.state.agreed": "Согласовано",
    "shows.detail.state.past": "Прошло",
    "shows.detail.acts": "Выступления",
    "shows.detail.noActs": "На этом шоу пока нет артистов.",
    "shows.detail.riderVersion": "Райдер v{version}",
    "shows.detail.noRider": "Райдера пока нет",
    "shows.detail.newerVersion": "Есть более новая версия: v{version}",
    "shows.detail.getLink": "Показать ссылку на шоу",
    "shows.detail.linkFailed": "Не удалось получить ссылку: {error}",
    "shows.detail.sketchTitle": "Набросок — пока ни даты, ни площадки",
    "shows.detail.sketchHint": "Укажите дату или площадку — и это станет обычным шоу.",
    "shows.detail.sketchWhere": "Дата и площадка",
    "shows.detail.change": "Изменить дату и площадку",
    "shows.detail.changeNeedsDate": "Выберите дату: у шоу она уже есть.",
    "shows.detail.sketchSave": "Сохранить дату и площадку",
    "shows.detail.sketchNeeds": "Сначала выберите дату или площадку.",
    "shows.detail.saveFailed": "Не удалось сохранить: {error}",
    "shows.offers.heading": "Предложения",
    "shows.offers.empty": "Предложений пока нет.",
    "shows.offers.sortLabel": "Сортировка",
    "shows.offers.sort.time": "Время (отправлено)",
    "shows.offers.sort.match": "Совпадение",
    "shows.offers.sort.fewestMissing": "Меньше всего недостающего",
    "shows.offers.sort.price": "Цена",
    "shows.offers.sort.priceNotYet": "пока нет",
    "shows.offers.match": "{n} совпадает",
    "shows.offers.missing": "{n} не хватает",
    "shows.offers.riderChanged": "Райдер изменился v{from} → v{to}",
    "shows.offers.open": "Открыть предложение",
    "shows.offers.organiserApprove": "Утвердить как организатор",
    "shows.offers.organiserRequestChanges": "Запросить правки как организатор",
    "shows.offers.actionFailed": "Не удалось выполнить: {error}",
    // --- crew: экран работника и тестовая ссылка админа (SCRUM-762) ---
    "crew.untitledShow": "Шоу",
    "crew.dateOpen": "Дата не назначена",
    "crew.venueNone": "Площадка не назначена",
    "crew.signInWhy": "Это работа на шоу. Войдите или заведите аккаунт, чтобы её взять, — это минута.",
    "crew.signInToTake": "Войти и взять работу",
    "crew.take": "Взять работу",
    "crew.takenBySomeone": "Эту работу уже взял другой человек. Попросите у того, кто прислал ссылку, свою.",
    "crew.gone": "Такой ссылки на работу нет или её отозвали.",
    "crew.failed": "Что-то пошло не так: {error}",
    "crew.saveFailed": "Отметка не сохранилась: {error}",
    "crew.noRider": "У шоу ещё нет опубликованного райдера — отмечать нечего.",
    "crew.riderGone": "Райдер этого шоу больше не опубликован, поэтому списки пусты. Шаги остались.",
    "crew.riderMoved": "Райдер обновили после того, как договорились об этом шоу, — списки перед вами новые.",
    "crew.riderMovedOn": "Райдер обновлён {date} — новее того, о чём договаривались на это шоу. Списки перед вами новые.",
    "crew.tab.out": "Склад",
    "crew.tab.venue": "Площадка",
    "crew.tab.return": "Возврат",
    "crew.tab.plan": "План",
    "crew.time.warehouse": "Склад",
    "crew.time.truck": "Машина",
    "crew.time.venue": "Площадка",
    "crew.time.showRun": "Шоу",
    "crew.time.strike": "Демонтаж",
    "crew.thisPart": "Эта часть",
    "crew.doneOf": "{done} из {total}",
    "crew.done": "Сделано",
    "crew.twoPeople": "Нести вдвоём",
    "crew.showRunTwo": "вдвоём",
    "crew.kit.inside": "Что внутри",
    "crew.kit.cablesApart": "Кабели считаются в блоке «Кабели»",
    "crew.kit.included": "в коробке",
    "crew.kit.consumablesApart": "Батарейки и расходники считаются отдельной строкой",
    "crew.truckFront": "К КАБИНЕ",
    "crew.missing": "Нет",
    "crew.broken": "Сломано",
    "crew.missingOpen": "НЕ ВЕРНУЛОСЬ — остаётся открытым",
    "crew.brokenOpen": "СЛОМАНО — остаётся открытым",
    "crew.less": "На одну меньше",
    "crew.more": "На одну больше",
    "crew.tickAria": "{name}: {done} из {total}",
    "crew.hint.fromOffer": "В райдере этого нет — приходит из оффера проката",
    "crew.hint.nothing": "Здесь пусто",
    "crew.returnOpen": "Открытых строк: {n} (не вернулось, нет или сломано). Они остаются в списке проката — ничего не пропадает.",
    "crew.returnAllBack": "Всё вернулось.",
    // SCRUM-760: «Loading done — depart» gate. Translated like the neighbouring crew.* keys.
    "crew.gate.depart": "Погрузка закончена — выезжаем",
    "crew.gate.departVenue": "Погружено — уезжаем с площадки",
    "crew.gate.confirm": "Машина уезжает сейчас? Нажмите ещё раз",
    "crew.gate.waiting": "Ждём, когда водитель отправит машину",
    "crew.gate.departed": "Выехали в {time} · {name}",
    "crew.gate.departedNoName": "Выехали в {time}",
    "crew.gate.by.driver": "Отправил водитель",
    "crew.gate.by.supplier": "Отправила прокатная компания",
    "crew.gate.locked": "Машина уехала — погрузка закрыта. Если что-то забыли, попросите водителя открыть её снова.",
    "crew.gate.next": "Дальше — {tab}",
    "crew.gate.reopen": "Открыть погрузку снова",
    "crew.gate.failed": "Не удалось обновить отъезд: {error}",
    "crew.zoom": "Крупнее",
    "crew.fit": "Целиком",
    "crew.legendDone": "сделано {n}",
    "crew.legendPart": "частично {n}",
    "crew.legendTodo": "осталось {n}",
    "crew.legendMiss": "нет / сломано {n}",
    "crew.planHint": "Отметки ставятся в блоках; план показывает их по слоям, в порядке дня.",
    "crew.changeover.title": "Перестановки между выступлениями",
    "crew.changeover.heading": "Перестановка {from} → {to}",
    "crew.changeover.headingMin": "Перестановка {from} → {to} ({n} мин)",
    "crew.changeover.none": "Переносить нечего: всё, что нужно следующему выступлению, уже стоит на местах.",
    "crew.changeover.recheck": "Затем проверка линий, каналы: {channels}",
    "crew.zone.USR": "Сзади справа",
    "crew.zone.USC": "Сзади по центру",
    "crew.zone.USL": "Сзади слева",
    "crew.zone.SR": "Справа",
    "crew.zone.CS": "Центр сцены",
    "crew.zone.SL": "Слева",
    "crew.zone.DSR": "Спереди справа",
    "crew.zone.DSC": "Спереди по центру",
    "crew.zone.DSL": "Спереди слева",
    "crew.step.toWingsStand": "Убрать {item} на стойке за кулисы, кабель не отключать",
    "crew.step.rollOut": "Выкатить {item} за кулисы",
    "crew.step.back": "Вернуть {item} из-за кулис",
    "crew.step.swapStand": "Снять {from}, поставить {to} на ту же стойку",
    "crew.step.replace": "Заменить {from} на {to}",
    "crew.step.add": "Поставить {item}",
    "crew.step.bandOut": "Убрать со сцены инструменты и технику ({act}): {items}",
    "crew.step.bandIn": "Поставить инструменты и технику ({act}): {items}",
    "crew.layer.picked": "Собрано",
    "crew.layer.loaded": "Погружено",
    "crew.layer.placed": "Расставлено",
    "crew.layer.patched": "Скоммутировано",
    "crew.layer.checked": "Проверено",
    "crew.layer.unpatched": "Раскоммутировано",
    "crew.layer.struck": "Снято",
    "crew.layer.loadedback": "Погружено обратно",
    "crew.layer.returned": "Вернулось",
    "crew.phase.pick": "Сборка на складе",
    "crew.phase.pickSub": "В порядке выгрузки — машина грузится в обратном",
    "crew.phase.load": "Погрузка",
    "crew.phase.loadSub": "Обратный порядок · тяжёлое к кабине",
    "crew.phase.setup": "Выгрузка и сетап",
    "crew.phase.setupSub": "На площадке",
    "crew.phase.showRun": "Шоу",
    "crew.phase.showRunSub": "Бригада дежурит — задачи на сцене потом",
    "crew.phase.strike": "Демонтаж и погрузка",
    "crew.phase.strikeSub": "После шоу",
    "crew.phase.back": "Снова на складе",
    "crew.phase.backSub": "Выгрузить и принять — что вернулось, чего нет, что сломано",
    "crew.block.carts": "Тележки и пандус",
    "crew.block.racks": "Рэки и питание",
    "crew.block.pa": "P.A.",
    "crew.block.mon": "Мониторы",
    "crew.block.foh": "FOH",
    "crew.block.mics": "Микрофоны",
    "crew.block.dis": "DI-боксы",
    "crew.block.stands": "Стойки",
    "crew.block.backline": "Бэклайн",
    "crew.block.risers": "Подиумы и мебель",
    "crew.block.cables": "Кабели",
    "crew.block.other": "Прочее",
    "crew.block.loadOut": "Погрузка · {block}",
    "crew.block.unloadToPositions": "Выгрузка на места",
    "crew.block.unloadToPositionsSub": "Тяжёлое сразу на место, FOH на свою позицию",
    "crew.block.paMonitorsInPlace": "P.A. и мониторы на местах",
    "crew.block.powerPa": "Электричество P.A.",
    "crew.block.powerStage": "Электричество сцены",
    "crew.block.powerFoh": "Электричество FOH",
    "crew.block.paCheck": "Проверка P.A. и фронтфиллов",
    "crew.block.stageSet": "Сцена по райдеру",
    "crew.block.stageSetSub": "Параллельно с проверкой P.A.",
    "crew.block.patch": "Коммутация",
    "crew.block.patchSub": "Все входы инпут-листа",
    "crew.block.lineCheck": "Проверка линий",
    "crew.block.lineCheckSub": "Приходит инженер группы и начинает саундчек",
    "crew.block.showRun": "Шоу",
    "crew.block.showRunSub": "На сцене во время шоу",
    "crew.block.showRunN": "Шоу {n}",
    "crew.banner.powerOn": "Включение: сначала источники (пульт, стейджрэк, радиосистемы), потом усилители.",
    "crew.banner.powerOff": "Выключение: сначала усилители, потом источники (пульт, стейджрэк, радиосистемы).",
    "crew.block.unpatch": "Раскоммутация",
    "crew.block.clearSmall": "Со сцены · мелкое, лёгкое и провода",
    "crew.block.clearSmallSub": "Сначала микрофоны, DI, стойки, кабели",
    "crew.block.clearLarge": "Со сцены · крупное",
    "crew.block.clearLargeSub": "Комбики, подиумы, рояль, мониторы",
    "crew.block.fohPaLast": "FOH и P.A.",
    "crew.block.fohPaLastSub": "Последними — на сетапе первыми",
    "admin.crew.title": "Ссылка работника себе (для проверки)",
    "admin.crew.hint": "Ставит вас работником на одно из ваших шоу, чтобы попробовать экран работника с телефона. Откройте ссылку на телефоне и возьмите работу.",
    "admin.crew.show": "Шоу",
    "admin.crew.make": "Сделать ссылку работника",
    "admin.crew.made": "Ссылка готова. Откройте её на телефоне.",
    "admin.crew.link": "Ссылка работника",
    "admin.crew.open": "Открыть",
    "admin.crew.noShows": "У вас ещё нет шоу — сначала заведите его в Shows",
    "admin.crew.dateOpen": "без даты",
    "admin.crew.failed": "Не удалось: {error}",
    "admin.perf.title": "Добавить выступление в шоу",
    "admin.perf.hint": "Шоу становится многоактным: на вкладке «Площадка» по ссылке бригады появятся перестановки между выступлениями. Берётся шоу, выбранное выше.",
    "admin.perf.name": "Название выступления",
    "admin.perf.rider": "Райдер (опубликованный)",
    "admin.perf.noRider": "Райдера пока нет",
    "admin.perf.add": "Добавить выступление",
    "admin.perf.added": "Добавлено. В шоу выступлений: {n}.",
    "admin.perf.failed": "Не получилось добавить: {error}",
    "admin.perf.needName": "Назовите выступление",

    // --- rental desk (rental/desk-answer-panel.ts, rental/desk-shows-panel.ts, pages/warehouse-tabs.ts, SCRUM-647) ---
    "rental.tabsLabel": "Разделы склада",
    "rental.loadFailed": "Не удалось загрузить: {error}",
    "rental.toAnswer.heading": "Ждут ответа",
    "rental.toAnswer.empty": "Ничего не ждёт — на все офферы ответ дан.",
    "rental.cover.positions": "{n} позиций",
    "rental.cover.positionsOne": "{n} позиция",
    "rental.cover.ok": "{n} со склада",
    "rental.cover.short": "{n} не хватает",
    "rental.cover.missing": "{n} нет на складе",
    "rental.cover.answered": "отвечено {n}",
    "rental.cover.emptyWarehouse": "Склад пуст — добавьте технику, чтобы увидеть покрытие",
    "rental.reason.draft": "Ещё не отправлен",
    "rental.reason.changes": "Просят изменить",
    "rental.reason.reconfirm": "Райдер изменился — подтвердите заново",
    "rental.shows.heading": "Мои шоу",
    "rental.shows.empty": "Шоу пока нет. Шоу появится здесь, когда вы отправите оффер на дату.",
    "rental.shows.dateOpen": "Дата не задана",
    "rental.shows.venueNone": "Площадка не задана",
    "rental.shows.myOffer": "Мой оффер: {status}",
    "rental.crew.make": "Ссылка для бригады",
    "rental.crew.making": "Создаю…",
    "rental.crew.newLink": "Новая ссылка для бригады — отправьте её работнику",
    "rental.crew.linksHeading": "Ссылки для бригады",
    "rental.crew.free": "Ещё никто не взял",
    "rental.crew.takenBy": "Взял: {name}",
    "rental.crew.taken": "Взята",
    "rental.crew.failed": "Не удалось: {error}",
    "rental.crew.withdraw": "Отозвать",
    "rental.crew.withdrawSure": "Отозвать? Нажмите ещё раз",
    "rental.crew.withdrawFailed": "Не удалось отозвать ссылку: {error}",
    // SCRUM-760: driver link, role on a link row, the departure line. Translated like the neighbouring rental.crew.* keys.
    "rental.crew.driver": "Ссылка для водителя",
    "rental.crew.role.crew": "Бригада",
    "rental.crew.role.driver": "Водитель",
    "rental.crew.takeMyself": "Взять самому",
    "rental.crew.takenByYou": "Вы взяли",
    "rental.crew.openMine": "Открыть",
    "rental.depart.out": "Выехали со склада",
    "rental.depart.venue": "Выехали с площадки",
    "rental.depart.reopen": "Открыть погрузку снова",
    "rental.depart.failed": "Не удалось обновить отъезд: {error}",
    "rental.progress.heading": "Ход работ",
    "rental.tasks.heading": "Что делает бригада",
    "rental.tasks.blocks": "блоков: {n}",
    "rental.tasks.template": "Наш порядок работ",
    "rental.tasks.templateNote": "Одни и те же шаги на каждом шоу. У своего шоу к ним добавляются числа — что взять, скоммутировать и проверить по райдеру.",
    "rental.progress.doneOf": "{done} из {total}",
    "rental.progress.noLinks": "Ссылки для бригады ещё нет — ход работ появится, когда работник начнёт отмечать.",
    "rental.progress.noRider": "На этом шоу нет опубликованного райдера — считаются только шаги.",
    "rental.progress.failed": "Ход работ не загрузился: {error}",
};